/* eslint sort-keys-fix/sort-keys-fix: ["error", "asc", {natural: false}] */
const strings: { [key in string]: string } = {
  ACCEPT_ALL: 'Accept all',
  ACCESS_DEACTIVATED: 'Dashboard access deactivated',
  ACCESS_LEVEL_CHANGED: 'Permissions updated — can take up to an hour to apply',
  ACCESS_REACTIVATED: 'Dashboard access reactivated',
  ACCOUNT: 'Account',
  ACCOUNTING_AND_AUDITING: 'Accounting & Auditing',
  ACCOUNTS: 'Accounts',
  ACCOUNTS_SUBTITLE: 'Manage your organization and customer accounts',
  ACCOUNT_ALREADY_EXISTS: 'Account already exists',
  ACCOUNT_CREATION: 'Account creation',
  ACCOUNT_DETAILS: 'Account details',
  ACCOUNT_DETAILS_COPIED: 'Account details copied to clipboard',
  ACCOUNT_HASH: 'Account #',
  ACCOUNT_INFORMATION_ERROR:
    'We had a temporary problem finding your information, please try again later.',
  ACCOUNT_NAME: 'Account name',
  ACCOUNT_NAME_INVALID: 'Only letters, numbers, spaces, hyphens, and underscores are allowed',
  ACCOUNT_NAME_PLACEHOLDER: 'e.g., AR Collections',
  ACCOUNT_NAME_REQUIRED: 'Account name is required',
  ACCOUNT_NAME_TOO_LONG: 'Account name is too long',
  ACCOUNT_NOT_FOUND: 'Account not found',
  ACCOUNT_NUMBER: 'Account number',
  ACCOUNT_NUMBER_COPIED: 'Account number copied successfully',
  ACCOUNT_NUMBER_DETAILS: 'Account number',
  ACCOUNT_NUMBER_WITH_CURRENCY: 'Account number ({0})',
  ACCOUNT_SETUP: 'Account setup',
  ACCOUNT_TYPE: 'Account type',
  ACCOUNT_TYPE_CHECKING: 'Checking',
  ACCOUNT_TYPE_RUT: 'RUT',
  ACCOUNT_TYPE_SAVINGS: 'Savings',
  ACCOUNT_TYPE_VISTA: 'Vista',
  ACH: 'ACH',
  ACTIONS: 'Actions',
  ACTION_REQUIRED: 'Action required',
  ACTIVE: 'Active',
  ACTIVITY: 'Activity',
  ADD: 'Add',
  ADDITIONAL_DOCUMENTATION_REQUESTED:
    'Additional documentation has been requested for this transaction.',
  ADDRESS: 'Address',
  ADDRESS_COMPLEMENT: 'Address complement',
  ADD_ACCOUNT: 'Add account',
  ADD_APPROVAL_RULE: 'Add rule',
  ADD_CONTACT: 'Add contact',
  ADD_CONTACT_FLOW_MODAL_CURRENCY_DESCRIPTION: 'Currency: {0}',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_ACH: 'ACH, Wire or RTP',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_BI_FAST: 'BI-FAST (IDR)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_BOB_ACH: 'Local bank transfer (Bolivia)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CCE: 'CCE (PEN)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CHATS: 'CHATS',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CNAPS: 'CNAPS',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_COP: 'ACH Colombia',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CRYPTO: 'Stablecoins',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CVU: 'Bank transfer (CVU or CBU)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_EFT: 'EFT (CAD)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_FAST: 'FAST (TRY)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_FASTER_PAYMENTS: 'Faster Payments (GBP)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_GHIPSS: 'GHIPSS (GHS)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_IMPS: 'IMPS (INR)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_INSTAPAY: 'InstaPay (PHP)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_IPP: 'IPP (AED)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_MOBILE_WALLET: 'Mobile wallet',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_NIP: 'NIP (NGN)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_PESALINK: 'PesaLink (KES)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_PIX: 'Pix',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_PROMPTPAY: 'PromptPay (THB)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_RTC: 'RTC (ZAR)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_RTP: 'ACH, Wire or RTP',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_SEPA: 'SEPA',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_SPEI: 'Spei',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_SWIFT: 'Swift',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_TEF: 'TEF (CLP)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_WIRE: 'ACH, Wire or RTP',
  ADD_DIGITAL_DOLLARS_LEGACY: 'Add Digital dollars',
  ADD_DOCUMENTS: 'Add documents',
  ADD_FUNDS: 'Add funds',
  ADD_FX_MARKUP: 'Add your FX markup',
  ADD_FX_MARKUP_DESCRIPTION:
    'Earn revenue on customer transactions by adding a markup. Your spread will be included in the quote above.',
  ADD_NEW: 'Add new',
  ADD_NEW_CONTACT_WHICH_TYPE: 'What type of contact would you like to add?',
  ADD_NEW_CUSTOMER: 'Add customer',
  ADD_NEW_RECIPIENT: 'Add new recipient',
  ADD_NEW_ROLE: 'Add new role',
  ADD_NEW_USER: 'Add new user',
  ADD_NEW_WITHDRAWAL_ACCOUNT: 'Add new withdrawal account',
  ADD_NICKNAME: 'Add a nickname',
  ADD_PAYMENT_METHOD: 'Add payment method',
  ADD_PAYMENT_METHOD_TO_EXISTING_CONTACT_TITLE:
    'Would you like to add a payment method to an existing or new contact?',
  ADD_USDC: 'Add USDC',
  ADD_USD_ACCOUNT: 'Add USD account',
  ADD_YOUR_BUSINESS_INFORMATION: 'Add your business information',
  ADMIN: 'Admin',
  ADMINISTRATOR: 'Administrator',
  ADMIN_DESCRIPTION:
    'Team management, transaction capabilities, view and download transaction history and activity reports',
  ALL: 'All',
  ALL_TYPES: 'All types',
  ALREADY_HAVE_ACCOUNT: 'Already have an account?',
  AMOUNT: 'Amount',
  AMOUNT_ADDED_TO_WALLET: 'Amount added to wallet',
  AMOUNT_BIGGER_THAN_BALANCE: 'Amount cannot be greater than your balance (${0})',
  AMOUNT_EXCEEDS_AVAILABLE_EARNINGS: 'Amount cannot be greater than your available earnings ({0})',
  AMOUNT_TO_CONVERT: 'Amount to convert',
  AND_READ_UNDERSTOOD_OUR: 'and that you have read and understood our',
  ANNOUNCEMENT_ACKNOWLEDGE_AND_CLOSE: 'Acknowledge and close',
  ANNOUNCEMENT_ACKNOWLEDGE_ERROR: 'Something went wrong. Please try again.',
  ANNOUNCEMENT_BACK: 'Back',
  ANNOUNCEMENT_CLOSE: 'Close announcement',
  ANNOUNCEMENT_FEATURE: 'Feature announcement',
  ANNOUNCEMENT_GOT_IT: 'Got it',
  ANNOUNCEMENT_NEXT: 'Next',
  ANNOUNCEMENT_NEXT_STEP: 'Next step',
  ANNOUNCEMENT_PREVIOUS_STEP: 'Previous step',
  ANY: 'Any',
  AN_ERROR_OCCURRED: 'An unknown error occurred, please try again later.',
  API_CREDENTIALS: 'API credentials',
  API_CREDENTIALS_KEYS_SECTION_DESCRIPTION:
    'Use these to authenticate your integration with the Caliza API. Treat the secret values like passwords.',
  API_CREDENTIALS_KEYS_SECTION_LABEL: 'Keys and secrets',
  API_CREDENTIALS_UPDATE_ERROR: 'Could not update API credentials',
  API_CREDENTIALS_UPDATE_SUCCESS: 'API credentials updated',
  API_CREDENTIALS_WEBHOOK_SECTION_DESCRIPTION:
    'Where we send webhook events and who we notify about integrator activity.',
  API_CREDENTIALS_WEBHOOK_SECTION_LABEL: 'Webhook configuration',
  API_ERROR_CORRIDOR_NOT_AVAILABLE:
    'This transfer route is not available yet for the selected currency and destination. Please contact support to enable it.',
  API_ERROR_INSUFFICIENT_BALANCE:
    'Insufficient balance. Try a smaller amount or fund the account first.',
  API_ERROR_PAYMENT_APPROVAL_NO_ELIGIBLE_APPROVER:
    'This payment requires approval, but your organization has no eligible approver other than you. An admin needs to grant the approval permission to another team member.',
  API_ERROR_RECIPIENT_CRYPTO_NOT_APPROVED:
    'This crypto recipient has not been approved yet. Please contact support to enable it.',
  API_ERROR_RECIPIENT_NOT_FOUND: 'Recipient not found. Please select a different recipient.',
  API_ERROR_RECIPIENT_UNDER_REVIEW:
    'This recipient is under review and cannot be used for transfers yet. Please contact support.',
  API_ERROR_RECIPIENT_VALIDATION:
    'We could not validate the recipient details. Please review and try again.',
  API_ERROR_SIMULATION_MAXIMUM_AMOUNT: 'Amount is above the maximum allowed for this corridor.',
  API_ERROR_SIMULATION_MAXIMUM_AMOUNT_VALUE:
    'Amount is above the maximum allowed for this corridor ({0}).',
  API_ERROR_SIMULATION_MINIMUM_AMOUNT: 'Amount is below the minimum allowed for this corridor.',
  API_ERROR_SIMULATION_MINIMUM_AMOUNT_VALUE:
    'Amount is below the minimum allowed for this corridor ({0}).',
  API_ERROR_TRANSACTION_MINIMUM_AMOUNT: 'The minimum amount for this transaction is {0}.',
  API_ERROR_TRANSACTION_MINIMUM_NOT_CONFIGURED:
    'A minimum amount is not configured for this corridor. Please contact support.',
  API_ERROR_TRAVEL_RULE_OWNERSHIP_PROOF_REQUIRED:
    'This self-hosted wallet requires a verified ownership proof before you can simulate or send this operation. Verify wallet ownership for the selected recipient first.',
  API_ERROR_TRAVEL_RULE_PROOF_INVALID:
    'The signature could not be verified for this wallet address. Make sure you sign with the wallet that owns the registered address.',
  API_USER: 'API user',
  API_USER_HELPER:
    'API users access the platform programmatically and skip two-factor authentication setup.',
  APPEARANCE: 'Appearance',
  APPLY: 'Apply',
  APPROVAL_ADMIN_INITIATED_DESCRIPTION:
    'When off, transfers and withdrawals started by an admin skip approval. When on, admins are subject to the same rules as everyone else.',
  APPROVAL_ADMIN_INITIATED_DISABLED_HINT:
    'This applies once at least one approval rule is enabled.',
  APPROVAL_ADMIN_INITIATED_LABEL: 'Also require approval for transactions initiated by admins',
  APPROVAL_ADMIN_INITIATED_TOGGLE_ERROR: 'Could not update the setting. Please try again.',
  APPROVAL_NOTE_OPTIONAL: 'Note (optional)',
  APPROVAL_RULE: 'Approval rule',
  APPROVAL_RULE_CURRENCY_ALREADY_USED: 'A rule for this wallet currency already exists',
  APPROVAL_RULE_DELETE_ERROR: 'Could not delete the rule. Please try again.',
  APPROVAL_RULE_DELETE_SUCCESS: 'Rule deleted',
  APPROVAL_RULE_DISABLED: 'Disabled',
  APPROVAL_RULE_ENABLED: 'Enabled',
  APPROVAL_RULE_SAVE_ERROR: 'Could not save the rule. Please try again.',
  APPROVAL_RULE_SAVE_SUCCESS: 'Rule saved',
  APPROVAL_RULE_TOGGLE_ERROR: 'Could not update the rule. Please try again.',
  APPROVAL_RULE_VALUE_INVALID: "The amount can't be negative.",
  APPROVAL_RULE_ZERO_THRESHOLD_HINT:
    'If {0} all transfers and withdrawals from the selected Caliza wallet will be held for approval.',
  APPROVE: 'Approve',
  APPROVED: 'Approved',
  APPROVED_DESC: 'Your transaction was approved.',
  APP_ERROR_BOUNDARY_DESCRIPTION:
    'An unexpected error occurred. Please refresh the page and try again.',
  APP_ERROR_BOUNDARY_REFRESH: 'Refresh page',
  APP_ERROR_BOUNDARY_TITLE: 'Something went wrong',
  APP_ERROR_BOUNDARY_TRY_AGAIN: 'Try again',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACCOUNT_DESCRIPTION: 'This actions not reversible.',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACCOUNT_TITLE:
    'Are you sure you want to delete this account?',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CONTACT_TITLE:
    'Are you sure you want to delete this contact?',
  ARE_YOU_SURE_YOU_WANT_TO_LEAVE_WITHOUT_HASH:
    'Are you sure you want to leave without providing a transaction hash?',
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THESE_USERS_FROM_YOUR_TEAM: `Are you sure you want to remove {0} from your team?`,
  ASSET_TYPE: 'Asset type',
  AVAILABLE_BALANCE: 'Earnings available to claim',
  AVAILABLE_BALANCE_TOOLTIP:
    "This is your earned markup balance. It's separate from your USDC treasury balance.",
  AVAILABLE_BY_DEFAULT: 'Available by default',
  AWAITING_APPROVAL: 'Awaiting approval',
  AWAITING_APPROVAL_DESC: 'Your transaction is awaiting approval.',
  AWAITING_FUNDING_ALERT:
    'This transaction has a guaranteed exchange rate and is waiting to be funded.',
  AWAITING_FUNDING_ALERT_TRANSACTIONS_LIST_ACTION: 'View transaction details to complete.',
  AWAITING_FUNDING_ALERT_TRANSACTION_DETAILS_DRAWER_ACTION:
    'Fund this transaction before it expires.',
  AWAITING_FUNDING_BANNER_PLURAL: 'You have {0} transactions waiting to be funded.',
  AWAITING_FUNDING_BANNER_SINGULAR: 'You have 1 transaction waiting to be funded.',
  AWAITING_FUNDING_FILTER_LABEL: 'Only show transactions awaiting funding',
  BACK: 'Back',
  BACK_TO_APPLICATION: 'Back to application',
  BACK_TO_CUSTOMER: 'Back to customer',
  BACK_TO_DASHBOARD: 'Back to dashboard',
  BACK_TO_LOGIN: 'Back to sign in',
  BALANCE: 'Balance',
  BANK: 'Bank',
  BANK_ACCOUNT: 'Bank account',
  BANK_ACCOUNT_INFORMATION: 'Bank account information',
  BANK_ACCOUNT_NUMBER: 'Bank account number',
  BANK_ACCOUNT_TYPE: 'Bank account type',
  BANK_ADDRESS: 'Bank address',
  BANK_CODE: 'Bank code',
  BANK_CODE_CNAPS: 'Bank Code (CNAPS)',
  BANK_CODE_CNAPS_NOT_FOUND:
    "Bank not found — type the 12-digit CNAPS code if you can't find your bank",
  BANK_INFORMATION: 'Bank information',
  BANK_NAME: 'Bank name',
  BANK_NETWORK: 'Bank / network',
  BENEFICIARIES: 'Beneficiaries',
  BENEFICIARY_ADDRESS: 'Beneficiary address',
  BENEFICIARY_NAME: 'Beneficiary name',
  BENEFICIARY_ONBOARDING_INVITED_BY: '{0} at {1} invited you to Caliza',
  BENEFICIARY_ONBOARDING_PARTNERED_WITH_CALIZA:
    '{0} has partnered with Caliza to power international payments. Set a password to see your operations, track funds and payments, and download transaction reports.',
  BENEFICIARY_ONBOARDING_PARTNERED_WITH_CALIZA_FOR:
    '{0} has partnered with Caliza to power international payments. Set a password to track funds, see payments and download transaction reports for',
  BENEFICIARY_OR_RECIPIENT_CONTACT: 'Beneficiary or recipient contact',
  BENEFICIARY_ROLE: 'Beneficiary',
  BENEFIT_CROSS_BORDER_SUPPLY_CHAIN: 'Cross-Border Supply Chain',
  BENEFIT_CROSS_BORDER_SUPPLY_CHAIN_DESCRIPTION:
    'Simplify international accounts payable & accounts receivable',
  BENEFIT_GLOBAL_MERCHANT_SETTLEMENT: 'Global Merchant Settlement',
  BENEFIT_GLOBAL_MERCHANT_SETTLEMENT_DESCRIPTION:
    'Instant payouts for marketplaces, e-commerce and platforms',
  BENEFIT_INTERNATIONAL_PAYROLL: 'International Payroll',
  BENEFIT_INTERNATIONAL_PAYROLL_DESCRIPTION: 'Pay your international workforce in USDC',
  BENEFIT_TREASURY_MANAGEMENT: 'Treasury Management',
  BENEFIT_TREASURY_MANAGEMENT_DESCRIPTION:
    'Optimize international treasury operations and cash balances',
  BRAZILIAN_PIX: 'Brazilian real (Pix)',
  BRL1_WALLET: 'BRL1 wallet',
  BRL_MARKET_HOURS_ALERT:
    'BRL operations can only be completed during business hours: Monday to Friday, 9:00 AM – 3:40 PM BRT (excluding holidays).',
  BUSINESS: 'Business',
  BUSINESS_EMAIL: 'Business email',
  BUSINESS_INFORMATION: 'Business information',
  BUSINESS_NAME: 'Business name',
  BUSINESS_RELATIONSHIP: 'Business relationship',
  BY_CONFIRMING_EMAIL_AGREE: 'By confirming your email, you agree to our',
  CALIZA_ACCOUNT: 'Caliza account ({0})',
  CALIZA_BENEFITS: 'Caliza benefits',
  CALIZA_DOES_NOT_CHARGE_DEPOSIT_FEES:
    'Caliza does not charge any deposit fees. However, your external wallet may charge fees to transfer funds.',
  CALIZA_RATE: 'Caliza rate',
  CALIZA_RATE_TOOLTIP: 'Caliza rate includes {0} FX spread',
  CALIZA_TERMS_AND_SERVICES: "Caliza's Terms and Services",
  CALIZA_WALLET: 'Caliza wallet',
  CALIZA_WALLET_BALANCE: 'Caliza wallet balance',
  CALIZA_WALLET_FEE_NOTE: 'Fees may apply',
  CALLBACK_URL: 'Callback URL',
  CANCEL: 'Cancel',
  CANCEL_TRANSFER: 'Cancel transfer',
  CANT_SCAN_THE_CODE: "Can't scan the code?",
  CHAIN: 'Chain',
  CHAIN_ETHEREUM: 'Ethereum',
  CHAIN_POLYGON: 'Polygon',
  CHAIN_TRON: 'TRON',
  CHAIN_UNKNOWN: 'Unknown',
  CHANGE_PASSWORD_DESCRIPTION: 'Confirmation when your password is changed',
  CHANGE_PASSWORD_LABEL: 'Change password',
  CHECKING: 'Checking',
  CHECK_EMAIL_FOR_CODE: 'Please check {0} to retrieve your one-time passcode',
  CHECK_HISTORY_DESCRIPTION:
    'Check your history to track the status of the transfer. Transaction details can take a few minutes before they appear.',
  CHECK_YOUR_PAYMENT_HISTORY_TO_TRACK_STATUS:
    'Check your payment history to track the status of the payment.',
  CHOOSE_DEPOSIT_AMOUNT: 'Choose deposit amount',
  CITY: 'City',
  CLABE_INVALID: 'CLABE must be exactly 18 digits',
  CLAIM: 'Claim',
  CLAIM_EARNINGS: 'Claim earnings',
  CLEAR: 'Clear',
  CLICK_HERE: 'click here',
  CLIENT_ID: 'Client ID',
  CLIENT_SECRET: 'Client secret',
  CLOSE: 'Close',
  CODE_EXPIRED: 'Code has expired. Please request a new one',
  CODE_RESENT: 'Code resent',
  COMING_SOON: 'Coming soon',
  COMMA_AND_ONE: ', and one',
  COMMA_ONE: ', one',
  COMPANY: 'Company',
  COMPLETED: 'Completed',
  COMPLETED_DESCRIPTION:
    'Get notified when a transfer is complete and the recipient has received their funds',
  COMPLETED_LABEL: 'Complete',
  COMPLETED_STATUS: 'Completed',
  CONFIRM: 'Confirm',
  CONFIRM_DEPOSIT: 'Confirm Deposit',
  CONFIRM_EARNINGS_CLAIM: 'Confirm earnings claim',
  CONFIRM_INTERNAL_TRANSFER: 'Confirm internal transfer',
  CONFIRM_NEW_PASSWORD: 'Confirm new password',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PAYMENT: 'Confirm payment',
  CONFIRM_WITHDRAWAL: 'Confirm withdrawal',
  CONTACT: 'Contact',
  CONTACTS: 'Contacts',
  CONTACT_DETAILS: 'Contact details',
  CONTACT_EMAILS: 'Contact emails',
  CONTACT_EMAILS_HELPER: 'Comma-separated list of email addresses',
  CONTACT_NICKNAME: 'Contact nickname',
  CONTACT_TYPE: 'Contact type',
  CONTINUE: 'Continue',
  CONTINUE_WITH_GOOGLE: 'Continue with Google',
  CONVERSION_QUOTE: 'Conversion quote',
  CONVERSION_RATES: 'Conversion rates',
  CONVERT: 'Convert',
  CONVERTED_CURRENCY: 'Converted currency',
  CONVERT_ACCOUNT_BALANCE: 'Convert account balance',
  CONVERT_SUCCESS: 'Conversion completed successfully',
  COPIED: 'Copied to clipboard',
  COPIED_TO_CLIPBOARD: 'Copied to clipboard',
  COPY: 'Copy',
  COPY_ALL: 'Copy all',
  COPY_CLABE: 'Copy CLABE',
  COPY_LINK: 'Copy link',
  COUNTRY: 'Country',
  COUNTRY_NOT_SUPPORTED_PREFIX: "We can't pay out to ",
  COUNTRY_NOT_SUPPORTED_SUFFIX: '.',
  COUNTRY_OF_RESIDENCE: 'Country of residence',
  COUNTRY_RESTRICTED_PREFIX: 'Payouts to ',
  COUNTRY_RESTRICTED_SUFFIX: ' are restricted.',
  COUNT_OF_COUNT_COMPLETE: '{0} of {1} complete',
  CO_CC_LABEL: 'Cédula de Ciudadanía',
  CO_CE_LABEL: 'Cédula de Extranjería',
  CO_NIT_LABEL: 'Número de Identificación Tributaria',
  CO_SPECIAL_RESIDENCE_PERMIT: 'Permiso Especial de Permanencia',
  CREATE: 'Create',
  CREATED: 'Created',
  CREATED_DESC: 'Your transaction was created.',
  CREATED_WAITING_FUNDING_DESC: 'Your transaction was created and is waiting to be funded.',
  CREATE_A_CALIZA_ACCOUNT: 'Create a\nCaliza account',
  CREATE_CUSTOM_ROLE_NAME: 'Create a name for this custom role:',
  CREATE_INTEGRATOR_SUCCESS: 'Integrator created successfully',
  CREATE_TRANSACTIONS: 'Create transactions',
  CREATE_USD_ACCOUNT: 'Create USD account',
  CREATE_USD_ACCOUNT_DESCRIPTION:
    'Enable a USD account for this customer to unlock powerful banking features.',
  CREATE_USD_ACCOUNT_DISABLED_TOOLTIP:
    'USD account creation not enabled, please contact Caliza team to enable it.',
  CREATE_USER_FAILED: 'An error occurred while creating user',
  CREATE_USER_SUCCESS: 'User created successfully',
  CREATING: 'Creating',
  CROSS_BORDER_SUPPLY_CHAIN: 'Cross-Border Supply Chain',
  CROSS_BORDER_SUPPLY_CHAIN_DESC: 'Simplify international accounts payable & accounts receivable',
  CRYPTO_ACCOUNT_INFORMATION: 'Stablecoin account information',
  CRYPTO_DEPOSIT_COMPLETED_DESCRIPTION:
    'Check your activity to track the status of the transfer. Transaction details can take a few minutes before they appear. ',
  CRYPTO_DEPOSIT_COMPLETED_TITLE: 'Once we receive your funds, we will complete your deposit',
  CRYPTO_HASH_TRANSFER_MODAL_DESCRIPTION:
    'The transaction hash to automatically reconcile your incoming deposit.',
  CRYPTO_HASH_TRANSFER_MODAL_TITLE: 'Share the transaction hash provided by your external wallet',
  CRYPTO_INTERNAL_TRANSFER: 'Internal transfer',
  CRYPTO_NETWORK: 'Network',
  CRYPTO_NON_CUSTODIAL_WALLET: 'Non-custodial wallet (self-hosted)',
  CRYPTO_THIRD_PARTY_ADDRESS_INFO:
    "Regulations require the wallet owner's address for transfers to third-party self-hosted wallets.",
  CRYPTO_TRANSFER_COMPLETED_DESCRIPTION:
    'Check your activity to track the status of the transfer. Transaction details can take a few minutes before they appear. ',
  CRYPTO_TRANSFER_COMPLETED_TITLE: 'Once we receive your funds, we will complete your transfer',
  CRYPTO_TRANSFER_MODAL_DESCRIPTION:
    'Copy the transaction hash from your wallet or exchange and paste it here so we can verify your deposit. Once confirmed, your transfer will be completed and shown in your transaction history.',
  CRYPTO_TRANSFER_MODAL_SEND_FUNDS_DESCRIPTION:
    'Send funds to the wallet address below. Once we receive your transfer, it will be completed and shown in your transaction history.',
  CRYPTO_TRANSFER_MODAL_SEND_FUNDS_TITLE: 'Send funds to this wallet address',
  CRYPTO_TRANSFER_MODAL_TITLE: 'Share transaction hash to complete your operation',
  CRYPTO_VASP: 'Virtual Asset Service Provider (VASP)',
  CRYPTO_VASP_NAME: 'VASP name',
  CRYPTO_VASP_OTHER: 'Other (type VASP name)',
  CRYPTO_WALLET_ADDRESS: 'Wallet address',
  CURRENCY_CONVERT_TO_STABLECOIN:
    '{0} will automatically convert to a stablecoin once we receive your deposit.',
  CURRENCY_TYPE: 'Currency type',
  CURRENCY_TYPE_LABEL: 'Currency type',
  CURRENT_PASSWORD: 'Current password',
  CUSTOM: 'Custom',
  CUSTOMER: 'Customer',
  CUSTOMERS: 'Customers',
  CUSTOMERS_SUBTITLE: 'Manage customers onboarding',
  CUSTOMER_ACCOUNTS: 'Customer accounts',
  CUSTOMER_ACCOUNT_BALANCES: 'Customer balances',
  CUSTOMER_BALANCE: 'Customer Balance',
  CUSTOMER_GETS: 'Customer gets',
  CUSTOMER_RATE_TOOLTIP: 'Customer rate includes your {0} FX markup',
  CUSTOMER_SUCCESS: 'Customer Success',
  CUSTOMER_TYPE: 'Customer type',
  CUSTOMER_VERIFICATION_CREATE_ERROR: 'Failed to create customer verification',
  CUSTOMER_VERIFICATION_ERROR: 'An error occurred during verification',
  CUSTOMER_VERIFICATION_INFO: 'Please finish set up for verification to continue transfers',
  CUSTOMER_VERIFICATION_STARTED_SUCCESS:
    'Pending customer verification saved. It can be safely abandoned and resumed later if needed.',
  CUSTOMER_VERIFICATION_SUCCESS: 'Verification completed successfully',
  CVU: 'CVU',
  CVU_OR_CBU: 'CVU or CBU',
  DARK: 'Dark',
  DASHBOARD_ACCESS: 'Dashboard access',
  DASHBOARD_ACCESS_ALREADY_GRANTED: 'This customer already has dashboard access',
  DASHBOARD_ACCESS_DESCRIPTION:
    'Give this customer a sign-in to manage their own account — balances, activity, recipients and payments.',
  DASHBOARD_ACCESS_LOAD_ERROR: 'We could not load dashboard access for this customer',
  DASHBOARD_ACCESS_NONE_YET: "This customer doesn't have dashboard access yet.",
  DASHBOARD_ACCESS_NONE_YET_HINT: "They'll get an email invitation to set their password.",
  DASHBOARD_ACCESS_REQUIRES_APPROVAL: "Available once this customer's verification is approved.",
  DATE: 'Date',
  DATE_AND_TIME: 'Date and time',
  DAY: 'Day',
  DEACTIVATE: 'Deactivate',
  DEACTIVATED: 'Deactivated',
  DEACTIVATED_ON: 'Deactivated {0}',
  DEACTIVATE_ACCESS_DESCRIPTION:
    '{0} will immediately lose access to the dashboard. You can reactivate this sign-in at any time.',
  DEACTIVATE_ACCESS_TITLE: 'Deactivate dashboard access?',
  DEACTIVATE_ACCOUNT: 'Deactivate account',
  DEACTIVATE_USER: 'Deactivate user',
  DECLINED: 'Declined',
  DEFAULT: 'Default',
  DELETE: 'Delete',
  DELETE_ACCOUNT: 'Delete account',
  DELETE_APPROVAL_RULE: 'Delete rule',
  DELETE_APPROVAL_RULE_CONFIRM_DESCRIPTION:
    'Transactions will no longer be held for approval by this rule.',
  DELETE_APPROVAL_RULE_CONFIRM_TITLE: 'Delete this approval rule?',
  DELETE_CONTACT: 'Delete contact',
  DELETE_CONTACT_SUCCESS: 'Contact deleted successfully',
  DELETE_PAYMENT_METHOD_SUCCESS: 'Payment method deleted successfully',
  DEPARTMENT: 'Department',
  DEPOSIT: 'Deposit',
  DEPOSITING_FOR: 'Depositing for',
  DEPOSIT_ACTION: 'Deposit',
  DEPOSIT_COMPLETED: 'Deposit Completed',
  DEPOSIT_COMPLETED_DESC: 'Your deposit has been completed.',
  DEPOSIT_COMPLETED_DESCRIPTION: 'Get notified when a deposit has been completed',
  DEPOSIT_COMPLETED_LABEL: 'Complete',
  DEPOSIT_COMPLETED_TITLE: 'Your funds have been added',
  DEPOSIT_CREATED_DESCRIPTION: 'Get notified when a deposit has been created',
  DEPOSIT_CREATED_LABEL: 'Created',
  DEPOSIT_CREDENTIALS_DESCRIPTION:
    'Transfer USD from your bank using the deposit details provided.\n\nWe will credit your account automatically when funds arrive.',
  DEPOSIT_CREDENTIALS_TITLE: 'Send funds from your bank',
  DEPOSIT_DETAILS: 'Deposit details',
  DEPOSIT_FAILED_DESCRIPTION: 'Get notified when a deposit has failed',
  DEPOSIT_FAILED_LABEL: 'Failed',
  DEPOSIT_FIAT_ACCOUNT_MODAL_DESCRIPTION:
    'Once we receive your funds from your bank, we will automatically send your transfer and confirm via email and your transaction history.',
  DEPOSIT_FROM: 'Deposit from {0}',
  DEPOSIT_PENDING_DESCRIPTION:
    'We received your {0} and are processing your deposit. Deposits can take up to 4 minutes to complete. You can track the status of your deposit in Activity.',
  DEPOSIT_PENDING_TITLE: 'We are depositing your funds',
  DEPOSIT_RECEIVED: 'Deposit Received',
  DEPOSIT_RECEIVED_DESC: 'Your deposit has been received.',
  DEPOSIT_STATUS: 'Deposit status',
  DEPOSIT_TRANSACTION_HASH: 'Deposit transaction hash',
  DESCRIPTION_OF_ROLE_OPTIONAL: 'Description of Role (Optional)',
  DESELECT_ALL: 'Deselect all',
  DESTINATION_COUNTRY: `Country of recipient's account`,
  DESTINATION_TYPE: 'Destination type',
  DETAILS: 'Details',
  DEVICE_NAME: 'Device name',
  DEVICE_NAME_HELP: 'Optional: Give this device a name for easy identification',
  DEVICE_NAME_PLACEHOLDER: 'My Phone',
  DISABLE: 'Disable',
  DISABLE_TWO_FACTOR_AUTHENTICATION_TITLE: 'Are you sure you want to disable 2FA?',
  DISABLING: 'Disabling...',
  DOCUMENT_NUMBER_CPF_CNPJ: 'Document number (CPF/CNPJ)',
  DOCUMENT_NUMBER_INVALID: 'Document number must be a valid CPF (11 digits) or CNPJ (14 digits)',
  DOCUMENT_WITH_NAME_TEMPLATE: 'Document {0}',
  DONE: 'Done',
  DONT_HAVE_ACCOUNT: "Don't have an account?",
  DONT_SUPPORT_COUNTRY: "We don't support your country yet",
  DOWNLOAD: 'Download',
  DOWNLOAD_COMPROVANTE_OPERACAO_TRANSACTION_DOCUMENT:
    'Comprovante de operação de pagamento internacional',
  DOWNLOAD_DETAILED_PAYMENT_CONFIRMATION_TRANSACTION_DOCUMENT: 'Detailed transaction confirmation',
  DOWNLOAD_PAYMENT_CONFIRMATION_TRANSACTION_DOCUMENT: 'Transaction confirmation',
  DOWNLOAD_PDF: 'Download PDF',
  DOWNLOAD_TRANSACTION_DOCUMENTS: 'Download transaction documents',
  EARNED: 'Earned',
  EARNINGS: 'Earnings',
  EARNINGS_AVAILABLE: 'Earnings available: {0} {1}',
  EARNINGS_CLAIM_NO_FEES:
    'Claiming your earnings is fee-free. The full amount will be transferred to your selected destination.',
  EARNINGS_CLAIM_SUCCESS: 'Your earnings claim has been submitted',
  EARNINGS_DASHBOARD: 'Earnings Dashboard',
  EARNINGS_DETAILS: 'Earnings details',
  EDIT: 'Edit',
  EDIT_APPROVAL_RULE: 'Edit rule',
  EDIT_NICKNAME: 'Edit nickname',
  EDIT_RECIPIENT_TABS: 'Edit recipient tabs',
  EMAIL: 'Email',
  EMAIL_INVALID_FORMAT: 'Email format is not valid',
  EMAIL_NOT_AVAILABLE: 'This email cannot be used',
  ENABLE: 'Enable',
  ENABLING: 'Enabling...',
  ENTER_TOTP_CODE: 'Enter code',
  ENTER_VERIFICATION_CODE: 'Enter verification code',
  ENTER_VERIFICATION_CODE_DESCRIPTION:
    'Enter the 6-digit code from your authenticator app to complete setup',
  ERROR_DISPLAYING_ROW_DATA: 'Error displaying row data',
  ERROR_LOADING_CUSTOMER: 'Error loading customer details',
  ERROR_LOADING_EARNINGS: 'Error loading earnings data',
  ERROR_LOADING_PREFERENCES: 'Error loading preferences',
  EXCHANGE: 'Exchange',
  EXCHANGE_COMPLETED: 'Exchange completed',
  EXCHANGE_COMPLETED_DESC: 'Your exchange has been completed.',
  EXCHANGE_RATE_LOCK: 'Exchange rate lock',
  EXISTING_CONTACT: 'Existing contact',
  EXPIRED: 'Expired',
  EXPIRED_DESC: 'This transaction has expired',
  EXTERNAL_ACCOUNT: 'External',
  EXTERNAL_ACCOUNT_ACH: 'External',
  EXTERNAL_ACCOUNT_COP: 'External',
  EXTERNAL_ACCOUNT_CVU: 'External',
  EXTERNAL_ACCOUNT_DESTINATION: 'External account',
  EXTERNAL_ACCOUNT_ETH: 'External',
  EXTERNAL_ACCOUNT_NO_FEE_NOTE: 'No additional fees',
  EXTERNAL_ACCOUNT_PIX: 'External',
  EXTERNAL_ACCOUNT_POLYGON: 'External',
  EXTERNAL_ACCOUNT_SPEI: 'External',
  EXTERNAL_ACCOUNT_SWIFT: 'External',
  EXTERNAL_ACCOUNT_TRON: 'External',
  EXTERNAL_ACCOUNT_WIRE: 'External',
  EXTERNAL_PAYMENT_REFERENCE_OPTIONAL: 'External payment reference (Optional)',
  EXTERNAL_RECIPIENT: 'External recipient',
  FAILED: 'Failed',
  FAILED_DESC: 'Your payment has failed',
  FAILED_DESCRIPTION: 'Get notified when a transfer has failed',
  FAILED_LABEL: 'Failed',
  FAILED_TO_LOAD_STATES: 'Failed to load states for the selected country.',
  FAILED_TO_LOAD_TRANSACTION_STATUS: 'Failed to load transaction status',
  FEATURE_NOT_AVAILABLE_DESCRIPTION:
    'We apologize for the inconvenience. This feature exists but is temporarily disabled. Please check back later for updates.',
  FEATURE_NOT_AVAILABLE_TITLE: 'Feature currently unavailable',
  FEE: 'Fee',
  FEES: 'Fees',
  FIAT_ACCOUNT_ACH: 'Bank Account (ACH)',
  FIAT_ACCOUNT_BI_FAST: 'Bank Account (BI-FAST)',
  FIAT_ACCOUNT_BOB_ACH: 'Bank Account (Bolivia)',
  FIAT_ACCOUNT_CCE: 'Bank Account (CCE)',
  FIAT_ACCOUNT_CHATS: 'Bank Account (CHATS)',
  FIAT_ACCOUNT_CNAPS: 'Bank Account (CNAPS)',
  FIAT_ACCOUNT_COP: 'COP',
  FIAT_ACCOUNT_CRYPTO: 'Stablecoin Wallet',
  FIAT_ACCOUNT_CVU: 'Bank transfer (CVU or CBU)',
  FIAT_ACCOUNT_EFT: 'Bank Account (EFT)',
  FIAT_ACCOUNT_FAST: 'Bank Account (FAST)',
  FIAT_ACCOUNT_FASTER_PAYMENTS: 'Bank Account (Faster Payments)',
  FIAT_ACCOUNT_GHIPSS: 'Bank Account (GHIPSS)',
  FIAT_ACCOUNT_IMPS: 'Bank Account (IMPS)',
  FIAT_ACCOUNT_INSTAPAY: 'Bank Account (InstaPay)',
  FIAT_ACCOUNT_IPP: 'Bank Account (IPP)',
  FIAT_ACCOUNT_MOBILE_WALLET: 'Mobile wallet',
  FIAT_ACCOUNT_NIP: 'Bank Account (NIP)',
  FIAT_ACCOUNT_PESALINK: 'Bank Account (PesaLink)',
  FIAT_ACCOUNT_PIX: 'Pix',
  FIAT_ACCOUNT_PROMPTPAY: 'Bank Account (PromptPay)',
  FIAT_ACCOUNT_RTC: 'Bank Account (RTC)',
  FIAT_ACCOUNT_RTP: 'Bank Account (RTP)',
  FIAT_ACCOUNT_SEPA: 'Bank Account (SEPA)',
  FIAT_ACCOUNT_SPEI: 'SPEI',
  FIAT_ACCOUNT_SWIFT: 'Bank Account (SWIFT)',
  FIAT_ACCOUNT_TEF: 'Bank Account (TEF)',
  FIAT_ACCOUNT_WIRE: 'Bank Account (Wire)',
  FIAT_INTERNAL_TRANSFER: 'Internal transfer',
  FILE_NAME_AND_SIZE_TEMPLATE: 'File name {0} - {1}',
  FILL_ALL_ENTRIES_AND_SUBMIT: 'Fill all entries and submit',
  FILL_OUT_DETAILS_FOR_NEW_MEMBER:
    'Fill out details for your new team member and they will receive an email shortly after sending an invite.',
  FILTER: 'Filter',
  FILTER_WITH_COUNT: 'Filter ({0})',
  FINANCE_AND_TREASURY: 'Finance & Treasury',
  FIRST_NAME: 'First name',
  FIRST_NAME_IS_EMPTY_ERROR: 'First name cannot be empty',
  FOUR_STEPS_BEFORE_FIRST_PAYMENT: 'Four steps before your first payment',
  FROM: 'From',
  FROM_DATE: 'From ({0})',
  FUNCTIONALITIES: 'Functionalities',
  FUNDING_METHOD: 'Funding method',
  FUNDING_WITH: 'Funding with {0}',
  FX_LOCK_DEFAULT_LABEL: 'Standard (2h)',
  FX_LOCK_DURATION: 'Duration: {0}h',
  FX_LOCK_HOURS: '{0}h',
  FX_LOCK_NO_EXTRA_SPREAD: 'No extra spread',
  FX_LOCK_OPTION: '{0} — {1}',
  FX_LOCK_RATE_SPREAD: '(Rate lock spread: +{0})',
  FX_LOCK_RATE_TOOLTIP: 'Rate lock includes {0}% FX spread',
  FX_LOCK_SPREAD: '{0}% spread',
  FX_MARKUP_AMOUNT_AFTER_EXCHANGE: 'Amount after exchange',
  FX_MARKUP_APPLY: 'Apply markup',
  FX_MARKUP_BPS_HINT: '100 bps = 1%',
  FX_MARKUP_BPS_LABEL: 'Markup (bps)',
  FX_MARKUP_CUSTOMER_PAYS: 'Customer pays',
  FX_MARKUP_CUSTOMER_QUOTE_PREVIEW: 'Customer quote preview',
  FX_MARKUP_CUSTOMER_RATE: 'Customer rate',
  FX_MARKUP_CUSTOMER_RATE_TOOLTIP:
    'The FX rate after your markup. Rails may add a network fee — see it in the transaction details.',
  FX_MARKUP_EARNINGS: 'FX markup earnings',
  FX_MARKUP_FIXED_BASED_ON_INPUT: 'Fixed based on your input',
  FX_MARKUP_MODAL_SUBTITLE: 'Set your spread for this transaction.',
  FX_MARKUP_MODAL_TITLE: 'Add FX markup',
  FX_MARKUP_OUR_SPREAD: '(Our spread: +{0})',
  FX_MARKUP_RATE_BREAKDOWN: 'FX rate breakdown',
  FX_MARKUP_TOTAL_SPREAD: '{0} total spread',
  FX_MARKUP_YOUR_SPREAD: '(Your spread: +{0})',
  FX_MARKUP_YOU_EARN: 'You earn',
  FX_RATE_LOCK: 'Rate lock duration',
  FX_RATE_LOCK_DESCRIPTION:
    'Lock your exchange rate for longer. Longer locks have a higher spread.',
  GENERATE_STATEMENT_DESCRIPTION:
    'Select an account and period. The statement includes beginning and ending balances.',
  GENERATE_STATEMENT_TITLE: 'Generate a statement',
  GET_HELP: 'Get help',
  GLOBAL_BUSINESS_ACCOUNTS: 'Global Business Accounts in USDC',
  GLOBAL_MERCHANT_SETTLEMENT: 'Global Merchant Settlement',
  GLOBAL_MERCHANT_SETTLEMENT_DESC: 'Instant payouts for marketplaces, e-commerce and platforms',
  GOT_IT: 'Got it',
  GROSS_AMOUNT: 'Gross amount',
  HELP: 'Help',
  HIDE: 'Hide',
  HIDE_PASSWORD: 'Hide password',
  HIDE_ROLE_DETAILS: 'Hide role details',
  HOME: 'Home',
  HOUR: 'hour',
  HOURS: 'hours',
  HOW_IT_WORKS_USD_ACCOUNTS_1: 'Get ACH / Wire / SWIFT details to receive USD deposits',
  HOW_IT_WORKS_USD_ACCOUNTS_2: 'Send payouts in your name',
  HOW_IT_WORKS_USD_ACCOUNTS_3: 'Create multiple accounts to automate reconciliation',
  HOW_IT_WORKS_USD_ACCOUNTS_DESC: 'Add bank details to receive and send USD in your name.',
  HOW_IT_WORKS_USD_ACCOUNTS_TITLE: 'USD account details',
  HOW_IT_WORKS_USD_BALANCE_1:
    'Fund USD from local deposits (SPEI/Pix) or from your Caliza USDC/USDT balances',
  HOW_IT_WORKS_USD_BALANCE_2: 'Send payouts from your USD balance (sender: Caliza)',
  HOW_IT_WORKS_USD_BALANCE_3: 'No USD account details for ACH / Wire / SWIFT deposits',
  HOW_IT_WORKS_USD_BALANCE_DESC: 'Hold USD and send payouts worldwide.',
  HOW_IT_WORKS_USD_BALANCE_TITLE: 'USD balance',
  HOW_NAMED_PAYMENTS_WORK_BODY:
    "Payments sent in your customer's name require USD account details for that customer. If no USD account details have been created yet, the customer can still fund payments from their USD balance, but the recipient will see your name on the payout.",
  HOW_NAMED_PAYMENTS_WORK_TITLE: 'How named payments work',
  HOW_THIS_WORKS: 'How this works',
  IBAN: 'IBAN',
  IBAN_ACCOUNT_NUMBER: 'IBAN / Account number',
  IBAN_DETAILS: 'IBAN',
  IBAN_VALIDATION_INVALID_ACCOUNT_NUMBER: 'Invalid Account Number',
  IBAN_VALIDATION_INVALID_COUNTRY: 'Invalid IBAN of country {0}, for country {1}',
  IBAN_VALIDATION_INVALID_FORMAT: 'Invalid IBAN format',
  IBAN_VALIDATION_INVALID_IBAN: 'Invalid IBAN',
  IBAN_VALIDATION_NOT_FOUND: 'No bank found for this IBAN',
  IBAN_VALIDATION_TOO_SHORT_4: 'Must be large than 4 characters',
  IDENTIFIER: 'Identifier',
  IDP_LINK_ALREADY_VERIFIED: 'If you already verified the email in a different browser',
  IDP_LINK_CONTINUE_SUFFIX: 'to continue.',
  IDP_LINK_EMAIL_SENT_PREFIX: 'An email with instructions to link {0} account',
  IDP_LINK_EMAIL_SENT_SUFFIX: 'with your Caliza Customer Dashboard account has been sent to you.',
  IDP_LINK_NOT_RECEIVED: "Haven't received a verification code in your email?",
  IDP_LINK_RESEND_SUFFIX: 'to resend the email.',
  IDP_LINK_TITLE: 'Link {0}',
  IDP_LINK_USER_EXISTS: 'User with email {0} already exists. How do you want to continue?',
  IDP_LINK_VERIFY_EMAIL: 'You need to verify your email address to link your account with {0}',
  'ID_#': 'ID #',
  IFSC_CODE: 'IFSC code',
  INCOMPLETE_STATUS: 'Incomplete',
  INCORRECT_CODE: 'Incorrect code. Please try again',
  INCORRECT_EMAIL_PASSWORD: 'Incorrect email or password',
  INDIVIDUAL: 'Individual',
  INFORMATION_FOR_PAYMENT_BENEFICIARY_OR_RECIPIENT:
    'Information for payment beneficiary or recipient',
  INITIATOR_AWAITING_APPROVAL_HINT:
    "A teammate will review this transaction. You can't approve or reject your own transaction.",
  INITIATOR_AWAITING_APPROVAL_QUOTE_HINT:
    "A teammate will review this transaction and refresh the quote if it expires. You can't approve or reject your own transaction.",
  INSTALL_AUTHENTICATOR_APP: 'Install an authenticator app',
  INSTALL_AUTHENTICATOR_APP_DESCRIPTION: 'Download and install an authenticator app such as {0}',
  INSTANT_GLOBAL_PAYMENTS: 'Instant Global Payments',
  INSUFFICIENT_FUNDS: 'Insufficient funds',
  INTEGRATOR_EARNINGS_SUBTITLE:
    'Track your markup earnings, view transaction details and manage settlements',
  INTERNAL_NOTES_DESCRIPTION:
    'You can view attachments and notes in your activity for future reference. This is for your eyes only.',
  INTERNAL_NOTES_OPTIONAL: 'Internal notes (Optional)',
  INTERNAL_TRANSFER: 'Internal transfer',
  INTERNAL_TRANSFER_ACTION: 'Internal transfer',
  INTERNAL_TRANSFER_COMPLETED: 'Internal transfer completed',
  INTERNAL_TRANSFER_COMPLETED_DESCRIPTION:
    "Funds have been moved between your wallets. The recipient's balance will update shortly.",
  INTERNAL_TRANSFER_DIRECTION: 'Direction',
  INTERNAL_TRANSFER_FROM_CUSTOMER: 'From customer',
  INTERNAL_TRANSFER_FROM_CUSTOMER_DESCRIPTION: 'Customer → master',
  INTERNAL_TRANSFER_NOTES: 'Internal transfer notes or memo',
  INTERNAL_TRANSFER_TO_CUSTOMER: 'To customer',
  INTERNAL_TRANSFER_TO_CUSTOMER_DESCRIPTION: 'Master → customer',
  INTERNATIONAL_PAYROLL: 'International Payroll',
  INTERNATIONAL_PAYROLL_DESC: 'Pay your international workforce in USDC',
  INVALID_OTP: 'Invalid code. Please try again.',
  INVALID_SWIFT_CODE_FOR_IBAN: 'Swift code does not match IBAN',
  INVITATION_EXPIRED: 'Invitation expired',
  INVITATION_RESENT: 'Invitation sent again',
  INVITATION_REVOKED: 'Invitation revoked',
  INVITATION_SENT: 'Invitation sent',
  INVITATION_SENT_SUCCESS: 'Invitation sent',
  INVITE: 'Invite',
  INVITED_ON: 'Invited {0}',
  INVITE_A_TEAM_MEMBER: 'Invite a team member',
  INVITE_SOMEONE_ELSE: 'Invite someone else',
  INVITE_TO_DASHBOARD: 'Invite to dashboard',
  INVITE_TO_DASHBOARD_DESCRIPTION: '{0} will receive an email with a link to set their password.',
  INVOICES_RECEIPTS_ETC: '(Invoices, receipts, etc)',
  IN_PROGRESS: 'In progress',
  IOF_WITH_PERCENTAGE: `IOF ({0})`,
  IS_POBO: 'I am instructing this payment on my client’s behalf',
  I_AGREE_TO_THE:
    'I hereby declare that the information I am providing is truthful and accurate to the best of my knowledge and have read and agree to ',
  JOIN_YOUR_TEAM_ON_CALIZA: 'Join your team on Caliza',
  KEEP_ACCOUNT: 'Keep account',
  KEEP_CONTACT: 'Keep contact',
  KEEP_TWO_FACTOR_AUTHENTICATION_ENABLED: 'Keep 2FA',
  LABEL_OR_TITLE: 'label',
  LANGUAGE: 'Language',
  LAST_NAME: 'Last name',
  LAST_NAME_IS_EMPTY_ERROR: 'Last name cannot be empty',
  LAST_SIGNED_IN_ON: 'Last signed in {0}',
  LEADERSHIP_EXECUTIVE: 'Leadership / Executive',
  LEARN_MORE: 'Learn more',
  LEAVE_ANYWAY: 'Leave anyway',
  LEAVE_WITHOUT_HASH_DESC: 'Operations without a transaction hash take longer to complete.',
  LEGAL: 'Legal',
  LEGAL_ENTITY_NAME: 'Legal entity name',
  LIGHT: 'Light',
  LINK_ACCOUNT: 'Link {0} to existing account',
  LINK_COPIED: 'Link copied successfully',
  LOADING_PLEASE_WAIT: 'Loading, please wait',
  LOADING_TRANSACTION_STATUS: 'Loading transaction status',
  LOAD_MORE: 'Load more',
  LOGIN_AND_SECURITY: 'Login & security',
  LOG_IN: 'Log in',
  MAKE_A_DEPOSIT: 'Make a Deposit',
  MAKE_A_TRANSFER: 'Make a transfer',
  MANAGE: 'Manage',
  MANAGE_PAYMENT_CONTACTS: 'Manage payment contacts',
  MANAGE_PAYOUTS: 'Manage payouts or receive funds instantly in stablecoins',
  MANAGE_ROLES: 'Manage roles',
  MANAGE_TEAM_AND_USERS: 'Manage team and users',
  MANAGE_USER: 'Manage user',
  MANAGE_USERS: 'Manage users',
  MANUAL_ENTRY_OPTION: 'Or enter this key manually in your authenticator app:',
  MARKUP: 'Markup',
  MARKUP_EARNED: 'Markup earned',
  MASTER_ACCOUNT: 'Master account',
  MASTER_CALIZA_ACCOUNT: 'Master Caliza account ({0})',
  MAX: 'Max',
  MEMO_OR_DESTINATION_OPTIONAL: 'Memo or Destination Tag (Optional)',
  METHOD: 'Method',
  MEXICAN_SPEI: 'Mexican pesos (SPEI)',
  MID_MARKET_RATE: 'Mid-market rate',
  MID_MARKET_RATE_SOURCE: 'source: XE',
  MINUTES: 'minutes',
  MISSING_INTEGRATOR_INFORMATION: 'Missing integrator information, please complete KYB',
  MISSING_TRADE_DOCUMENT_DETAILS: 'Trade document details are required for this currency',
  MOBILE_NUMBER: 'Mobile number',
  MOBILE_WALLET_INFORMATION: 'Mobile wallet information',
  MOBILE_WALLET_PROVIDER: 'Wallet provider (optional)',
  MONTH: 'Month',
  MORE: '+{0} more',
  MSISDN: 'Mobile money phone number',
  MXNB_WALLET: 'MXNB wallet',
  MXN_DEPOSIT_DETAILS_PROVISIONING:
    'Your MXN deposit account is being provisioned. Please try again in a few minutes.',
  MYSELF: 'Myself',
  NAME: 'Name',
  NATIONAL_ID_OPTIONAL: 'National ID (optional)',
  NEW_CONTACT: 'New contact',
  NEW_DEVICE_LOGIN_DESCRIPTION: 'Sign ins from a new device',
  NEW_DEVICE_LOGIN_LABEL: 'New device login',
  NEW_PASSWORD: 'New password',
  NEXT: 'Next',
  NICKNAME: 'Nickname',
  NICKNAME_INVALID_CHARACTERS:
    'Nickname can only contain letters, numbers, spaces, hyphens, and underscores',
  NICKNAME_OPTIONAL: 'Account nickname (optional)',
  NICKNAME_PLACEHOLDER: 'Account nickname',
  NICKNAME_REQUIRED_ERROR: 'Nickname cannot be empty',
  NICKNAME_UPDATED_SUCCESS: 'Nickname updated successfully',
  NINE_MIN: '9 min',
  NO: 'No',
  NOTIFICATIONS: 'Notifications',
  NOT_APPLICABLE: 'N/A',
  NOT_AVAILABLE_FOR_PAYOUTS: 'Not available for payouts',
  NOT_STARTED: 'Not started',
  NO_ACCOUNTS: 'No accounts',
  NO_ACTIVITY_YET_SUBTITLE: 'Send or receive funds and they will appear here.',
  NO_ACTIVITY_YET_TITLE: 'No activity yet',
  NO_BALANCES_YET: 'No balances available yet',
  NO_BENEFICIARIES_YET_MESSAGE: 'Approved customers will appear here as beneficiaries.',
  NO_BENEFICIARIES_YET_TITLE: 'No beneficiaries yet',
  NO_CUSTOMERS_YET_TITLE: 'No customers added yet',
  NO_CUSTOMER_ACTIVITY_VERIFICATION_INCOMPLETE:
    'You cannot send any funds until verification for this customer is complete and approved.',
  NO_DEPOSIT_OPTIONS_AVAILABLE: 'No deposit options available',
  NO_ILL_WAIT: "No, I'll wait",
  NO_ITEMS_FOUND: 'No items found',
  NO_NICKNAME: 'No account nickname set',
  NO_NUMBER: 'Password must have at least 1 number',
  NO_PAYMENT_METHODS_AVAILABLE: 'No payment methods available',
  NO_RECIPIENTS_MATCH_SEARCH: 'No recipients match your search',
  NO_RECIPIENT_ACCOUNTS: 'No recipient accounts',
  NO_RESULTS_FOUND: 'No results found',
  NO_SPECIAL_CHARACTER: 'Password must have at least 1 special character',
  NO_USD_ACCOUNTS_YET: 'No USD accounts yet',
  NUMBER: 'number',
  N_ACCOUNTS: '{0} accounts',
  ONE_TIME_PASSWORD: 'Verify with two-factor authentication',
  ONE_TIME_PASSWORD_DESCRIPTION: 'Enter the temporary code generated in your authenticator app',
  ONLY_CURRENCY_SUPPORTED_BY_COUNTRY: 'Only {0} are supported by this country.',
  OPERATIONS: 'Operations',
  OPERATIONS_WITHOUT_A_TRANSACTION_HASH_TAKE_LONGER:
    'Operations without a transaction hash take longer to complete.',
  OPERATOR: 'Operator',
  OPERATOR_DESCRIPTION:
    'Transaction capabilities, view and download transaction history and activity reports',
  OPTIONAL: 'Optional',
  OR: 'Or',
  ORIGINAL_TRANSACTION: 'Original transaction ID#',
  OTHER: 'Other',
  OTP_DIGIT: 'Digit {0}',
  OUTCOME: 'Outcome',
  PASSPORT: 'Passport',
  PASSWORD: 'Password',
  PASSWORDS_DO_NOT_MATCH: 'Passwords do not match',
  PASSWORD_DOES_NOT_MEET_REQUIREMENTS: 'Password does not meet the requirements',
  PASSWORD_IS_EMPTY_ERROR: 'Password cannot be empty',
  PASSWORD_MINIMUM: 'Password must have a minimum of',
  PAYMENT_APPROVALS: 'Payment approvals',
  PAYMENT_APPROVAL_AWAITING_DESCRIPTION:
    'Get notified when a transfer or withdrawal needs your approval, or when one you submitted is awaiting approval',
  PAYMENT_APPROVAL_AWAITING_LABEL: 'Awaiting approval',
  PAYMENT_APPROVAL_DECISION_DESCRIPTION:
    'Get notified when a transfer or withdrawal you submitted is approved or rejected',
  PAYMENT_APPROVAL_DECISION_LABEL: 'Approved or rejected',
  PAYMENT_APPROVAL_MISCONFIG_WARNING:
    'Approval rules are enabled, but your organization has no eligible approver other than you. Grant the approval permission to another team member so transactions can be approved.',
  PAYMENT_APPROVAL_MISCONFIG_WARNING_NO_ACCESS:
    'Approval rules are enabled, but your organization has no eligible approver other than you. Ask an admin to grant the approval permission to another team member so transactions can be approved.',
  PAYMENT_APPROVAL_NO_APPROVER_ALERT:
    'This transaction matches an approval rule ({0}), but your organization has no eligible approver other than you. An admin needs to grant the approval permission to another team member or disable the rule.',
  PAYMENT_APPROVAL_OPERATOR_GT: 'Greater than',
  PAYMENT_APPROVAL_RULES_DESCRIPTION:
    'Hold transfers and withdrawals for approval when a condition is met.',
  PAYMENT_APPROVAL_RULES_EMPTY: 'No approval rules yet.',
  PAYMENT_APPROVAL_RULES_LABEL: 'Payment approval rules',
  PAYMENT_APPROVAL_STATUS: 'Payment approvals',
  PAYMENT_APPROVAL_VARIABLE_BALANCE_DEBIT: 'Amount debited',
  PAYMENT_APPROVAL_VARIABLE_BALANCE_DEBIT_CONDITION: 'If amount is greater than',
  PAYMENT_APPROVAL_VARIABLE_BALANCE_DEBIT_DESCRIPTION:
    'The amount that leaves your Caliza wallet balance when the transaction executes, before any conversion.',
  PAYMENT_BENEFICIARY_INFO: 'Information for payment beneficiary or recipient',
  PAYMENT_COMPLETED: 'Payment completed',
  PAYMENT_COMPLETED_DESC: 'Your payment has been completed.',
  PAYMENT_IDENTIFIERS: 'Payment Identifiers',
  PAYMENT_INSTRUCTIONS: 'Payment Instructions',
  PAYMENT_METHOD: 'Payment method',
  PAYMENT_METHODS: 'Payment methods',
  PAYMENT_METHODS_FETCH_ERROR: 'An error occurred while trying to fetch the payment methods.',
  PAYMENT_RAIL_ACH_WIRE: 'ACH & Wire',
  PAYMENT_RAIL_FEE: '{0} fee',
  PAYMENT_RAIL_RTP: 'RTP',
  PAYMENT_RAIL_SWIFT: 'SWIFT',
  PAYMENT_REFERENCE: 'Payment reference ({0} characters max)',
  PAYMENT_REFERENCE_DESCRIPTION:
    'This is an optional payment reference for your recipient to see and verify your transfer.',
  PAYMENT_REFERENCE_DETAILS_LABEL: 'Payment reference',
  PAYMENT_REFERENCE_LABEL: 'Payment reference (200 character max)',
  PAYMENT_SENT: 'Payment sent',
  PAYMENT_SENT_DESC: 'Your payment has been sent.',
  PAYMENT_SENT_DESCRIPTION:
    'Get notified when a transfer is in progress, on its way to the recipient',
  PAYMENT_SENT_LABEL: 'Payment sent',
  PAYMENT_UNDER_REVIEW: 'Payment Under Review',
  PAYMENT_UNDER_REVIEW_DESC: 'Your payment is being reviewed for compliance.',
  PAYOR: 'Payor',
  PAYOUT_SUPPORTED: 'Payout supported',
  PENDING: 'Pending',
  PENDING_ACAM_220_FILE_ALERT: 'We are still waiting for you to submit your ACAM 220 file.',
  PENDING_ACAM_220_FILE_ALERT_TRANSACTIONS_LIST_ACTION: 'View transaction details to complete.',
  PENDING_ACAM_220_FILE_ALERT_TRANSACTION_DETAILS_DRAWER_ACTION:
    'Please click "Details" below, to upload the file.',
  PENDING_APPROVALS_BANNER_PLURAL: 'You have {0} payments awaiting approval.',
  PENDING_APPROVALS_BANNER_SINGULAR: 'You have 1 payment awaiting approval.',
  PENDING_DESC: 'Your payment is processing',
  PERMISSIONS: 'Permissions',
  PERMISSION_SEND_PAYMENTS: 'Send payments and convert',
  PERMISSION_SEND_PAYMENTS_HINT_OFF: 'Check for full access',
  PERMISSION_SEND_PAYMENTS_HINT_ON: 'Uncheck for read-only access',
  PERMISSION_VIEW: 'See balances, activity and recipients',
  PERMISSION_VIEW_HINT: 'Always included',
  PERSONAL_INFORMATION: 'Personal information',
  PIX: 'Pix',
  PIX_DEPOSIT_DESCRIPTION:
    'Once you are in your banking app, use the link below to complete your deposit using Pix. We will send you an email confirmation once your deposit is received.',
  PIX_KEY: 'PIX key',
  PREFERRED_LANGUAGE: 'Preferred language',
  PREVIEW: 'Preview',
  PRIVACY_POLICY: 'Privacy Policy',
  PROCEED_WITH_ACTION: 'Proceed with action',
  PROCESSED_BY_BANK: 'Processed by Bank',
  PROCESSED_BY_BANK_DESC: 'Your payment has been processed by the sending bank.',
  PROCESSED_BY_INTERMEDIARY_BANK: 'Processed by Intermediary Bank',
  PROCESSED_BY_INTERMEDIARY_BANK_DESC: 'Your payment has been processed by the intermediary bank.',
  PROCESSING: 'Processing',
  PROCESSING_DESC: 'Your payment is being processed.',
  PRODUCT_AND_TECHNOLOGY: 'Product & Technology',
  PRODUCT_CATEGORY_APPAREL: 'Apparel',
  PRODUCT_CATEGORY_AUTOMOTIVE: 'Automotive',
  PRODUCT_CATEGORY_COSMETICS: 'Cosmetics',
  PRODUCT_CATEGORY_ELECTRONICS: 'Electronics',
  PRODUCT_CATEGORY_FOOD_AND_BEVERAGE: 'Food & Beverage',
  PRODUCT_CATEGORY_FURNITURE: 'Furniture',
  PRODUCT_CATEGORY_MACHINERY: 'Machinery',
  PRODUCT_CATEGORY_OTHER: 'Other',
  PRODUCT_CATEGORY_RAW_MATERIALS: 'Raw Materials',
  PRODUCT_CATEGORY_TEXTILES: 'Textiles',
  PRODUCT_CATEGORY_TOYS: 'Toys',
  PROFILE: 'Profile',
  PROVIDE_THE_SIX_DIGIT_CODE: 'Provide the 6 digit code from your authenticator',
  PURPOSE_OF_TRANSFER_CAPITAL_INJECTION_INVESTMENT_DESCRIPTION: 'Equity, funding transfers',
  PURPOSE_OF_TRANSFER_CAPITAL_INJECTION_INVESTMENT_LABEL: 'Capital Injection / Investment',
  PURPOSE_OF_TRANSFER_COMMISSION_AND_AGENT_FEES_DESCRIPTION: 'Sales commissions, brokerage',
  PURPOSE_OF_TRANSFER_COMMISSION_AND_AGENT_FEES_LABEL: 'Commission & Agent Fees',
  PURPOSE_OF_TRANSFER_EFX_OPERATION_DESCRIPTION: 'ACAM220 for eFX operation',
  PURPOSE_OF_TRANSFER_EFX_OPERATION_LABEL: 'eFX operation',
  PURPOSE_OF_TRANSFER_INTERCOMPANY_TRANSFERS_DESCRIPTION: 'Between related entities',
  PURPOSE_OF_TRANSFER_INTERCOMPANY_TRANSFERS_LABEL: 'Intercompany Transfers',
  PURPOSE_OF_TRANSFER_INVOICE_AND_SUPPLIER_PAYMENTS_DESCRIPTION: 'Goods and services from vendors',
  PURPOSE_OF_TRANSFER_INVOICE_AND_SUPPLIER_PAYMENTS_LABEL: 'Invoice & Supplier Payments',
  PURPOSE_OF_TRANSFER_LICENSING_AND_ROYALTIES_DESCRIPTION: 'IP, software, patent payments',
  PURPOSE_OF_TRANSFER_LICENSING_AND_ROYALTIES_LABEL: 'Licensing & Royalties',
  PURPOSE_OF_TRANSFER_LOAN_REPAYMENT_AND_INTEREST_DESCRIPTION: 'Business loan payments',
  PURPOSE_OF_TRANSFER_LOAN_REPAYMENT_AND_INTEREST_LABEL: 'Loan Repayment & Interest',
  PURPOSE_OF_TRANSFER_LOGISTICS_AND_SHIPPING_DESCRIPTION: 'Freight, customs, warehousing',
  PURPOSE_OF_TRANSFER_LOGISTICS_AND_SHIPPING_LABEL: 'Logistics & Shipping',
  PURPOSE_OF_TRANSFER_MARKETING_AND_ADVERTISING_DESCRIPTION: 'Digital ads, campaigns, agencies',
  PURPOSE_OF_TRANSFER_MARKETING_AND_ADVERTISING_LABEL: 'Marketing & Advertising',
  PURPOSE_OF_TRANSFER_OPERATIONAL_EXPENSES_DESCRIPTION: 'Rent, utilities, insurance',
  PURPOSE_OF_TRANSFER_OPERATIONAL_EXPENSES_LABEL: 'Operational Expenses',
  PURPOSE_OF_TRANSFER_PAYROLL_AND_CONTRACTOR_PAYMENTS_DESCRIPTION: 'Salaries, wages, freelancers',
  PURPOSE_OF_TRANSFER_PAYROLL_AND_CONTRACTOR_PAYMENTS_LABEL: 'Payroll & Contractor Payments',
  PURPOSE_OF_TRANSFER_PROFESSIONAL_SERVICES_DESCRIPTION: 'Consulting, legal, accounting fees',
  PURPOSE_OF_TRANSFER_PROFESSIONAL_SERVICES_LABEL: 'Professional Services',
  PURPOSE_OF_TRANSFER_TAXES_DUTIES_AND_GOVERNMENT_FEES_DESCRIPTION: 'VAT, customs, regulatory',
  PURPOSE_OF_TRANSFER_TAXES_DUTIES_AND_GOVERNMENT_FEES_LABEL: 'Taxes, Duties & Government Fees',
  PURPOSE_OF_TRANSFER_TECHNOLOGY_SERVICES_DESCRIPTION: 'SaaS, cloud, IT infrastructure',
  PURPOSE_OF_TRANSFER_TECHNOLOGY_SERVICES_LABEL: 'Technology Services',
  PURPOSE_OF_TRANSFER_TRADE_FINANCE_DESCRIPTION: 'Letters of credit, trade settlements',
  PURPOSE_OF_TRANSFER_TRADE_FINANCE_LABEL: 'Trade Finance',
  QR_CODE: 'QR Code',
  QR_CODE_NOT_AVAILABLE: 'QR code not available',
  QUOTE_EXPIRED: 'Expired',
  QUOTE_EXPIRED_DESCRIPTION: 'Refresh to approve at the current rate.',
  QUOTE_EXPIRED_TITLE: 'This quote has expired',
  QUOTE_EXPIRES_IN: 'Expires in',
  QUOTE_ORIGINAL_MID_MARKET_RATE: 'Original mid-market rate: {0}',
  QUOTE_ORIGINAL_VALUE: 'Originally {0}',
  QUOTE_REFRESH: 'Refresh quote',
  QUOTE_REFRESH_ERROR: 'Could not refresh the quote. Please try again.',
  QUOTE_WILL_EXPIRE: 'This quote will expire in',
  REACTIVATE: 'Reactivate',
  REACTIVATE_BLOCKED_BY_ACTIVE_USER:
    'Deactivate the current dashboard user before restoring this sign-in.',
  REACTIVATE_BLOCKED_BY_INVITATION: 'Revoke the open invitation before restoring this sign-in.',
  RECEIVED_BY_BENEFICIARY_BANK: 'Received by Beneficiary Bank',
  RECEIVED_BY_BENEFICIARY_BANK_DESC: 'Your payment has been received by the beneficiary bank.',
  RECEIVED_BY_INTERMEDIARY_BANK: 'Received by Intermediary Bank',
  RECEIVED_BY_INTERMEDIARY_BANK_DESC: 'Your payment has been received by the intermediary bank.',
  RECEIVE_AND_SEND_USD: 'Receive and send USD using your own account and routing number',
  RECIPIENT: 'Recipient',
  RECIPIENTS: 'Recipients',
  RECIPIENTS_WALLET: "Recipient's wallet address",
  RECIPIENT_ADDRESS: 'Recipient address',
  RECIPIENT_DETAILS: 'Recipient details',
  RECIPIENT_EMAIL: 'Recipient email',
  RECIPIENT_GETS: 'Recipient gets',
  RECIPIENT_ID: 'Recipient ID',
  RECIPIENT_ID_TYPE: 'Recipient ID Type',
  RECIPIENT_INFORMATION: 'Recipient information',
  RECIPIENT_MEMO: 'Recipient memo',
  RECIPIENT_MEMO_OPTIONAL: 'Recipient memo (Optional)',
  RECIPIENT_NOT_FOUND: 'Recipient not found',
  RECIPIENT_TYPE: 'Recipient type',
  REFERENCE: 'Reference',
  REFUND: 'Refund',
  REFUNDED: 'Refunded',
  REFUNDED_ALERT: 'This transaction was refunded.',
  REFUNDED_ALERT_ACTION: 'See refund transaction in details.',
  REFUNDED_DESC: 'Your transaction was refunded.',
  REFUND_TO: 'Refund to {0}',
  REFUND_TRANSACTION: 'Refund transaction ID#',
  REGISTRATION_NUMBER: 'Registration number',
  REJECT: 'Reject',
  REJECTED: 'Rejected',
  REJECTED_DESC: 'Your transaction was rejected.',
  REMOVE: 'Remove',
  REMOVE_USERS_BUTTON_LABEL: 'Remove {0}',
  REQUIRED_ACCOUNT: 'Select account to continue',
  REQUIRED_AMOUNT: 'Amount cannot be empty',
  REQUIRED_FUNDING_METHOD: 'Select funding method to continue',
  REQUIRED_RECIPIENT: 'Recipient cannot be empty',
  REQUIRED_SUPPORTING_DOCUMENTATION: 'Supporting documentation is required',
  RESEND: 'Resend',
  RESEND_CODE: 'Resend code',
  RESEND_INVITE: 'Resend invite',
  RESEND_INVITE_ERROR: 'Error resending invitation',
  RESEND_INVITE_SUCCESS: 'Invitation resent successfully',
  RESET: 'Reset',
  RESETTING: 'Resetting...',
  RESET_PASSWORD: 'Reset password',
  RESET_PASSWORD_DESCRIPTION: 'Type in your current password to reset it',
  RESET_PASSWORD_FAILED: 'Reset password failed. Please try again.',
  RESET_PASSWORD_FORBIDDEN: 'Please provide your current password to reset it.',
  RESET_PASSWORD_SUCCESS: 'Password reset successfully',
  RESET_PASSWORD_TITLE: 'Reset password',
  RESULT: 'Result',
  RESUME_VERIFICATION: 'Resume verification',
  RETRY: 'Retry',
  RETURNED: 'Returned',
  RETURNED_DESC: 'Your transaction was returned.',
  REVEAL: 'Reveal',
  REVENUE_EARNINGS: 'Revenue earnings',
  REVERSAL: 'Reversal',
  REVERSAL_TRANSACTION: 'Reversal transaction ID#',
  REVERSED: 'Reversed',
  REVERSED_ALERT: 'This deposit was reversed.',
  REVERSED_ALERT_ACTION: 'See reversal transaction in details.',
  REVERSED_DESC: 'Your deposit was reversed.',
  REVIEW: 'Review',
  REVIEW_AND_SUBMIT: 'Review and submit',
  REVIEW_CONVERSION: 'Review conversion',
  REVIEW_PROFILE: 'Review profile',
  REVIEW_STATUS_APPROVED: 'Approved',
  REVIEW_STATUS_PENDING_REVIEW: 'Pending review',
  REVIEW_STATUS_REJECTED: 'Rejected',
  REVOKE: 'Revoke',
  REVOKE_INVITE: 'Revoke invite',
  REVOKE_INVITE_DESCRIPTION:
    'The invitation sent to {0} will stop working. You can send a new invitation at any time.',
  REVOKE_INVITE_TITLE: 'Revoke this invitation?',
  RISK_AND_COMPLIANCE: 'Risk & Compliance',
  ROLE: 'Role',
  ROLE_APPROVE_OR_REJECT_TRANSACTION: 'Approve or reject transactions',
  ROLE_CREATE_TRANSACTIONS: 'Create transactions',
  ROLE_CREATE_USD_ACCOUNT: 'Create USD accounts',
  ROLE_MANAGE_CUSTOMER: 'Manage customers',
  ROLE_MANAGE_PAYMENT_APPROVAL_RULES: 'Manage payment approval rules',
  ROLE_MANAGE_PAYMENT_CONTACTS: 'Manage payment contacts',
  ROLE_MANAGE_USER: 'Manage team and users',
  ROLE_NAME: 'Role name',
  ROLE_RECEIVE_TRANSACTION_STATUS_NOTIFICATIONS: 'Receive transaction status notifications',
  ROLE_VIEW_ACTIVITY: 'View and download transaction history and activity report',
  ROLE_VIEW_BENEFICIARIES: 'View accounts',
  ROLE_VIEW_INTEGRATOR_EARNINGS: 'View earnings',
  ROLE_VIEW_USD_ACCOUNT: 'View USD accounts',
  ROLE_WITHDRAW_INTEGRATOR_EARNINGS: 'Withdraw earnings',
  ROTATE: 'Rotate',
  ROTATE_WEBHOOK_SECRET: 'Rotate webhook secret',
  ROTATE_WEBHOOK_SECRET_CONFIRM_DESCRIPTION:
    'A new webhook secret will be generated. Your old secret will stop working immediately and any integration that depends on it will fail until you update it.',
  ROTATE_WEBHOOK_SECRET_CONFIRM_TITLE: 'Rotate webhook secret?',
  ROUTING_CODE_CAD: 'Transit + institution number',
  ROUTING_NUMBER: 'Routing number',
  ROUTING_NUMBER_COPIED: 'Routing number copied successfully',
  ROUTING_NUMBER_DETAILS: 'Routing number',
  ROUTING_NUMBER_WITH_CURRENCY: 'Routing number ({0})',
  RTP: 'RTP',
  RUNNING: 'Running',
  SALES: 'Sales',
  SAME_DAY_ACH: 'Same-day ACH',
  SAMPLE_RESPONSES: 'Sample responses',
  SAVE: 'Save',
  SAVE_AND_CLOSE: 'Save and close',
  SAVE_CHANGES: 'Save changes',
  SAVINGS: 'Savings',
  SCAN_QR_CODE: 'Scan the QR code',
  SEARCH: 'Search',
  SEARCH_BY_CURRENCY_OR_RAIL: 'Search by currency or rail',
  SEARCH_BY_NAME: 'Search by name',
  SEARCH_COUNTRIES: 'Search countries',
  SEARCH_RECIPIENTS_PLACEHOLDER: 'Search by name, nickname, bank or account',
  SECURE_AND_COMPLIANT: 'Secure and Compliant Crypto Ramps',
  SEE_ACCOUNTS: 'See accounts',
  SEE_ALL: 'See all',
  SEE_DETAILS: 'See details',
  SELECT_ACCOUNT: 'Select account',
  SELECT_ALL: 'Select all',
  SELECT_CONTACT_TYPE: 'Select contact type',
  SELECT_CUSTOMER: 'Select customer',
  SELECT_EXISTING_CONTACT: 'Select existing contact',
  SELECT_FILTERS_THAT_APPLY: 'Select any of the following filters to apply to your search',
  SELECT_FUNDING_CURRENCY: 'Select funding currency',
  SELECT_PAYMENT_METHOD: 'Select a payment method',
  SELECT_PURPOSE_FOR_TRANSFER: 'Select purpose for transfer',
  SELECT_RECIPIENT: 'Select recipient',
  SELECT_RECIPIENT_ACCOUNT: 'Select recipient account details',
  SELECT_RECIPIENT_ACCOUNT_DETAILS: 'Select recipient account details',
  SELECT_ROLE_FUNCTIONS: 'Select which functions this role has:',
  SELECT_TARGET_CURRENCY: 'Target currency',
  SELECT_TYPE: 'Select type',
  SELECT_WAYS_TO_USE_CALIZA: 'Select the ways you plan to use Caliza',
  SELF_APPROVAL_HINT: "You can't approve or reject your own payment.",
  SENDER: 'Sender',
  SENDER_INFORMATION: 'Sender Information',
  SENDER_NAME_NO_USD_DETAILS:
    "This customer doesn't have USD account details, so your name will appear on this payment.",
  SENDER_NAME_SHOWN_TO_RECIPIENT: 'Sender name shown to recipient',
  SEND_FUNDS_FROM_BANK: 'Send funds from your bank to complete transfer',
  SEND_FUNDS_TO_CALIZA_WALLET: 'Send funds to your Caliza account',
  SEND_FUNDS_TO_COMPLETE_TRANSFER: 'Send funds to complete transfer',
  SEND_INVITATION: 'Send invitation',
  SEND_TO_RECIPIENT: 'Send to recipient',
  SETTINGS: 'Settings',
  SETTINGS_UPDATE_ERROR: 'Settings update failed. Please try again.',
  SETTINGS_UPDATE_SUCCESS: 'Settings updated successfully',
  SETTLEMENT_CURRENCY: 'Settlement currency',
  SETTLEMENT_INSTANT: 'Instant',
  SETTLEMENT_INSTANT_MARKET_HOURS: 'Instant (during market hours)',
  SETTLEMENT_ONE_TO_THREE_DAYS: '1-3 business days',
  SETTLEMENT_ONE_TO_TWO_DAYS: '1-2 business days',
  SETTLEMENT_SAME_DAY_BEFORE_CUTOFF: 'Same day (if sent before daily cutoff)',
  SETTLEMENT_TIME: 'Settlement time',
  SETTLEMENT_UNKNOWN: 'Settlement time unavailable',
  SETTLEMENT_WITHIN_15_MINUTES: 'Typically within 15 minutes',
  SETTLEMENT_WITHIN_5_MINUTES: 'Typically within 5 minutes',
  SETUP_AUTHENTICATOR: 'Set up your authenticator',
  SET_NEW_PASSWORD: 'Set new password',
  SET_YOUR_PASSWORD: 'Set your password',
  SET_YOUR_PASSWORD_DESCRIPTION:
    'Your account is ready. Choose a password to sign in to your dashboard.',
  SHARE_TRANSACTION_HASH: 'Share transaction hash',
  SHOW_LESS: 'Show less',
  SHOW_MORE: 'Show more',
  SHOW_PASSWORD: 'Show password',
  SHOW_ROLE_DETAILS: 'Show role details',
  SIGN_IN: 'Sign in',
  SIGN_OUT: 'Sign out',
  SIGN_UP: 'Sign up',
  SIGN_UP_WITH_GOOGLE: 'Sign up with Google',
  SIX_DIGIT_AUTHENTICATOR_CODE: '6 digit authenticator code',
  SKIP_TWO_FACTOR_VERIFICATION: 'Skip two-factor verification',
  SPECIAL_CHARACTER: 'special character',
  SPEI_BANK_BENEFICIARY: 'Beneficiary',
  SPEI_BANK_NAME: 'Bank',
  SPEI_CLABE_COPIED: 'CLABE copied.',
  SPEI_DEPOSIT_DESCRIPTION: 'Use this CLABE Account to make your deposit.',
  STABLECOIN_BALANCES: 'Customer account balances',
  STABLECOIN_WALLET: 'Stablecoin wallet',
  START_CURRENCY: 'Starting currency',
  START_VERIFICATION: 'Start verification',
  STATE: 'State',
  STATEMENT_DISCLAIMER: 'Account balance statements are generated and provided by Caliza.',
  STATEMENT_FORMAT: 'Format',
  STATEMENT_FORMAT_CSV: 'CSV spreadsheet (Excel)',
  STATEMENT_FORMAT_PDF: 'PDF document',
  STATEMENT_MENU_ITEM: 'Statements',
  STATEMENT_PERIOD_ERROR: 'Select a valid period of up to one year',
  STATUS: 'Status',
  STEP: 'Step',
  STREET_ADDRESS: 'Street address',
  SUBMIT: 'Submit',
  SUBMITTED: 'Submitted',
  SUCCEEDED: 'Succeeded',
  SUCCEEDED_DESC: 'Your transaction has succeeded.',
  SUITE_FLOOR_APT: 'Suite / Floor / Apt',
  SUMMARY: 'Summary',
  SUPPORTED_ONLY: 'Supported only',
  SUPPORTING_DOCUMENTATION: 'Supporting documentation',
  SUPPORTING_DOCUMENTATION_DESCRIPTION:
    'For compliance reasons, this payment requires a supporting document, such as an invoice, contract or pay slip. This will not be sent to your recipient.',
  SWIFT: 'SWIFT',
  SWIFT_CODE: 'SWIFT code',
  SWIFT_CODE_DETAILS: 'Swift code',
  SWIFT_CODE_INVALID: 'SWIFT code must be 6 letters followed by 2 or 5 alphanumeric characters',
  SWIFT_CODE_NOT_FOUND: 'No bank found for this SWIFT code',
  SWIFT_CURRENCY_INSTRUCTED_VERSUS_SETTLEMENT_TOOLTIP: `Funds are instructed in {0}. Settlement currency depends on the recipient's bank and account.`,
  SWIFT_MINIMUM_AMOUNT: 'Minimum amount for SWIFT transfer is {0}',
  SWIFT_TO_WIRE_MORPH_NEEDS_ROUTING:
    'Payments to US banks are sent as domestic wires. Please enter the routing number and account number from your bank instructions.',
  SWIFT_TO_WIRE_MORPH_PREFILLED:
    "Payments to US banks are sent as domestic wires. We've populated the routing number from your bank's SWIFT code — please confirm and add the account number.",
  SWIFT_UPDATED_BADGE: 'Updated from IBAN',
  SYSTEM_ERROR: 'Something went wrong. Please try again.',
  TAX: `Tax ({0})`,
  TEN_MIN: '10 min',
  TERMS_ACCEPT_ERROR: 'You must accept the Terms of Service and Privacy Policy',
  TERMS_OF_SERVICE: 'Terms of Service',
  THEME: 'Theme',
  THESE_USERS: 'these users',
  THIS_ACTION_IS_NOT_REVERSIBLE: 'This actions not reversible.',
  THIS_MONTH: 'This month',
  THIS_QUOTE_WILL_REMAIN_ACTIVE_FOR: 'This quote will remain active for',
  THIS_USER: 'this user',
  THIS_WEEK: 'This week',
  TIMEZONE_ALASKA_STANDARD_TIME: 'Alaska Standard Time - AKST',
  TIMEZONE_ARGENTINA_TIME: 'Argentina Time - ART',
  TIMEZONE_BOLIVIA_TIME: 'Bolivia Time - BOT',
  TIMEZONE_BRAZIL_TIME: 'Brasília Time - BRT',
  TIMEZONE_CENTRAL_EUROPEAN_TIME: 'Central European Time - CET',
  TIMEZONE_CENTRAL_STANDARD_TIME: 'Central Standard Time - CST',
  TIMEZONE_CHILE_TIME: 'Chile Standard Time - CLT',
  TIMEZONE_COLOMBIA_TIME: 'Colombia Time - COT',
  TIMEZONE_EASTERN_EUROPEAN_TIME: 'Eastern European Time - EET',
  TIMEZONE_EASTERN_STANDARD_TIME: 'Eastern Standard Time - EST',
  TIMEZONE_ECUADOR_TIME: 'Ecuador Time - ECT',
  TIMEZONE_GREENWICH_MEAN_TIME: 'Greenwich Mean Time - GMT',
  TIMEZONE_GUYANA_TIME: 'Guyana Time - GYT',
  TIMEZONE_HAWAII_STANDARD_TIME: 'Hawaii Standard Time - HST',
  TIMEZONE_MOSCOW_TIME: 'Moscow Time - MSK',
  TIMEZONE_MOUNTAIN_STANDARD_TIME: 'Mountain Standard Time - MST',
  TIMEZONE_PACIFIC_STANDARD_TIME: 'Pacific Standard Time - PST',
  TIMEZONE_PARAGUAY_TIME: 'Paraguay Time - PYT',
  TIMEZONE_PERU_TIME: 'Peru Time - PET',
  TIMEZONE_SURINAME_TIME: 'Suriname Time - SRT',
  TIMEZONE_URUGUAY_TIME: 'Uruguay Time - UYT',
  TIMEZONE_VENEZUELA_TIME: 'Venezuela Time - VET',
  TIMEZONE_WESTERN_EUROPEAN_TIME: 'Western European Time - WET',
  TIME_ZONE: 'Time zone',
  TO: 'To',
  TODAY: 'Today',
  TOO_SHORT: 'Password too short, must have a minimum of 12 characters',
  TOTAL_ACROSS_N_ACCOUNTS: 'Total across {0} accounts',
  TOTAL_AMOUNT: 'Total amount',
  TOTAL_EARNINGS: 'Total earnings (lifetime)',
  TOTAL_FEES: 'Total fees',
  TOTAL_USD_BALANCE: 'Total USD balance',
  TOTP_APP_FREEOTP_NAME: 'FreeOTP',
  TOTP_APP_GOOGLE_NAME: 'Google Authenticator',
  TOTP_APP_MICROSOFT_AUTHENTICATOR_NAME: 'Microsoft Authenticator',
  TOTP_DISABLED_ERROR: 'An error occurred while disabling two-factor authentication',
  TOTP_DISABLED_SUCCESS: 'Two-factor authentication disabled successfully',
  TOTP_ENABLED_FAILED: 'An error occurred while enabling two-factor authentication',
  TOTP_ENABLED_SUCCESS: 'Two-factor authentication enabled successfully',
  TOTP_STEP_1: 'Open an authenticator app such as Google Authenticator or FreeOTP',
  TOTP_STEP_2: 'Scan the QR code using the authenticator app',
  TOTP_STEP_3: 'Enter the temporary code generated with your authenticator app',
  TO_DATE: 'To ({0})',
  TO_DATE_CANNOT_BE_AFTER_TODAY: 'End date cannot be after today',
  TO_DATE_MUST_BE_AFTER_FROM_DATE: 'End date must be after the start date',
  TRADE_DOCUMENT_ADD_PRODUCT: 'Add product',
  TRADE_DOCUMENT_CUSTOMS_DECLARATION_NO: 'Customs declaration number',
  TRADE_DOCUMENT_DETAILS_TITLE: 'Trade document details',
  TRADE_DOCUMENT_LOGISTICS_COMPANY: 'Logistics company',
  TRADE_DOCUMENT_LOGISTICS_ORDER_NO: 'Logistics order number',
  TRADE_DOCUMENT_PRODUCTS_TITLE: 'Products',
  TRADE_DOCUMENT_PRODUCT_CATEGORY: 'Product category',
  TRADE_DOCUMENT_PRODUCT_NAME: 'Product name',
  TRADE_DOCUMENT_QUANTITY: 'Quantity',
  TRADE_DOCUMENT_REMOVE_PRODUCT: 'Remove product',
  TRADE_DOCUMENT_SHIP_DATE: 'Ship date (optional)',
  TRANSACTIONS_CSV_MENU_ITEM: 'Transactions (CSV)',
  TRANSACTION_ACH_EFFECTIVE_DATE: 'Effective date',
  TRANSACTION_ACH_SEC_CODE: 'SEC code',
  TRANSACTION_ACH_TRACE_NUMBER: 'ACH trace number',
  TRANSACTION_APPROVAL_ERROR: 'Could not submit the decision. Please try again.',
  TRANSACTION_APPROVED_SUCCESS: 'Transaction approved',
  TRANSACTION_CONFIRMATION: 'Transaction confirmation',
  TRANSACTION_DETAILS: 'Transaction details',
  TRANSACTION_DETAILS_TITLE: 'Transaction details',
  TRANSACTION_HASH: 'Transaction hash',
  TRANSACTION_ID: 'Transaction ID#',
  TRANSACTION_IMAD: 'IMAD',
  TRANSACTION_NOT_AWAITING_APPROVAL_ERROR: 'This transaction is no longer awaiting approval.',
  TRANSACTION_NOT_FOUND: 'Transaction not found',
  TRANSACTION_OMAD: 'OMAD',
  TRANSACTION_PACS008: 'PACS008',
  TRANSACTION_REJECTED_SUCCESS: 'Transaction rejected',
  TRANSACTION_TYPE: 'Transaction type',
  TRANSACTION_UETR: 'UETR',
  TRANSFER: 'Transfer',
  TRANSFER_ACTION: 'Transfer',
  TRANSFER_CREATED_DESCRIPTION: 'Get notified when a transfer has been created',
  TRANSFER_CREATED_LABEL: 'Created',
  TRANSFER_FEES_FREE: 'Transfer fees (Free)',
  TRANSFER_FEES_WITH_PERCENTAGE: 'Transfer fees ({0})',
  TRANSFER_FUNDS: 'Transfer funds',
  TRANSFER_RECEIVED: "We've received your payment and initiated your transfer",
  TRANSFER_STATUS: 'Transfer status',
  TRANSFER_TO: 'Transfer to {0}',
  TRAVEL_RULE_BENEFICIARY_VASP: 'Beneficiary VASP',
  TRAVEL_RULE_COLLECTION_INCOMPLETE:
    'The wallet connection ended without a verified signature. Please try again.',
  TRAVEL_RULE_COLLECTION_TIMEOUT: 'The verification did not finish in time. Please try again.',
  TRAVEL_RULE_POPUP_BLOCKED:
    'Your browser blocked the verification window. Allow pop-ups for this site and try again.',
  TRAVEL_RULE_PROOF_REQUIRED: 'Wallet ownership verification required',
  TRAVEL_RULE_PROOF_REQUIRED_FIRST_PARTY_INFO:
    'Regulations require a one-time proof that you own this self-hosted wallet before funds can be sent to it. Connect the wallet and sign a message — it takes a minute and costs nothing.',
  TRAVEL_RULE_PROOF_REQUIRED_THIRD_PARTY_INFO:
    'Regulations require the owner of this self-hosted wallet to verify ownership of the wallet address before you can send funds to it. Start a test transfer and share the instructions with the wallet owner.',
  TRAVEL_RULE_SIGN_INSTEAD: 'Prefer to sign? Verify with your wallet signature instead',
  TRAVEL_RULE_START_TEST: 'Verify with a test transfer',
  TRAVEL_RULE_STATUS_CHECK_FAILED:
    'We could not check the wallet verification status. Please try again.',
  TRAVEL_RULE_TEST_AMOUNT: 'Exact amount ({0})',
  TRAVEL_RULE_TEST_AUTO_VERIFY:
    'Verification is automatic once the deposit arrives. When you see the test amount credited to your account balance, refresh the status here.',
  TRAVEL_RULE_TEST_CREDITED: 'The test amount is credited to your account balance once received.',
  TRAVEL_RULE_TEST_DESTINATION: 'Destination address',
  TRAVEL_RULE_TEST_FROM_WALLET:
    'The transfer must be sent from the wallet being verified ({0}) on the {1} network — transfers from exchanges or any other address will not match.',
  TRAVEL_RULE_TEST_INSTRUCTIONS:
    'To verify ownership, send the exact amount below to the destination address before {0}.',
  TRAVEL_RULE_TEST_PENDING: 'Test transfer pending',
  TRAVEL_RULE_TEST_REFRESH: 'Refresh status',
  TRAVEL_RULE_TEST_SHARE:
    'Share these instructions with the wallet owner — only they can send from this wallet.',
  TRAVEL_RULE_VASP_DID: 'VASP DID',
  TRAVEL_RULE_VASP_DID_COPIED: 'VASP DID copied successfully',
  TRAVEL_RULE_VERIFY_NOW: 'Verify with wallet signature',
  TREASURY_MANAGEMENT: 'Treasury Management',
  TREASURY_MANAGEMENT_DESC: 'Optimize international treasury operations and cash balances',
  TRY_CHANGING_YOUR_APPLIED_FILTERS: `Try changing your applied filters to see more {0}.`,
  TWELVE_CHARACTERS: 'twelve characters',
  TWO_FACTOR_AUTHENTICATION: 'Scan the QR code to get your temporary code',
  TWO_FACTOR_AUTHENTICATION_DESCRIPTION:
    'We encourage you to set up an authenticator app to best protect your account',
  TWO_FACTOR_AUTHENTICATION_SECTION_DESCRIPTION:
    'Prevent unauthorized access to your Caliza account by setting up two-factor authentication with an authenticator app',
  TWO_FACTOR_AUTHENTICATION_SECTION_LABEL: 'Two-factor authentication',
  TWO_FACTOR_AUTHENTICATION_SETUP: 'Set up two-factor authentication',
  TWO_FACTOR_AUTHENTICATION_SETUP_DESCRIPTION:
    'Scan this QR code with your authenticator app to set up two-factor authentication.',
  TWO_FACTOR_AUTHENTICATION_SETUP_SECRET: 'Or enter this secret key manually',
  TWO_FACTOR_DISABLED_ERROR: 'Failed to disable two-factor authentication. Please try again.',
  TWO_FACTOR_DISABLED_SUCCESS: 'Two-factor authentication has been disabled successfully.',
  TWO_FACTOR_RESET_ERROR: 'Failed to reset two-factor authentication. Please try again.',
  TWO_FACTOR_RESET_SUCCESS:
    'Two-factor authentication has been reset successfully. You will be logged out shortly.',
  TYPE: 'Type',
  UNKNOWN: 'Unknown',
  UNKNOWN_ERROR: 'Unknown error',
  UNSET: '(Unset)',
  UPDATE: 'Update',
  UPDATE_ACCOUNT_INFORMATION: 'Update account information',
  UPDATE_CONTACT_SUCCESS: 'Contact updated successfully',
  UPDATE_EMAIL_ADDRESS_DESCRIPTION:
    'Confirmation when you update your email address for your account',
  UPDATE_EMAIL_ADDRESS_LABEL: 'Updated email address',
  UPDATE_PAYMENT_METHOD_SUCCESS: 'Payment method updated successfully',
  UPLOAD_DOCUMENT: 'Upload document',
  UPLOAD_DOCUMENTS_NOT_ALLOWED: 'This transaction can no longer accept documents.',
  UPLOAD_ERROR_MESSAGE: 'Error uploading file. Please try again.',
  UPLOAD_FILE_TOO_LARGE: 'Each file must be 10 MB or smaller.',
  UPLOAD_SUCCESS_MESSAGE: 'File uploaded successfully',
  USDC_AND_USDT: 'USDC and USDT on & off ramps for businesses of all sizes',
  USDC_LABEL: 'USDC',
  USDC_WALLET: 'USDC wallet',
  USDT_WALLET: 'USDT wallet',
  USD_ACCOUNT: 'USD Account',
  USD_ACCOUNTS: 'USD account details',
  USD_ACCOUNT_BENEFIT_1: 'Receive USD via ACH, Wire, RTP or SWIFT with unique account details',
  USD_ACCOUNT_BENEFIT_2: 'Make named payouts on behalf of your customer',
  USD_ACCOUNT_BENEFIT_3: 'Hold USD balances with no conversion required',
  USD_ACCOUNT_CERT_AUTHORITY:
    'I certify that {0} is duly authorized by Caliza Financial Technologies, Inc. to open and manage this Caliza USD Virtual Account, including any required consents, approvals, and regulatory authorizations (where applicable).',
  USD_ACCOUNT_CERT_AUTHORITY_LABEL: 'Authority',
  USD_ACCOUNT_CERT_CUSTOMER_ONLY_USE:
    "I certify this account will be used only for Caliza Financial Technologies, Inc.'s transactions and funds, and not for any third party or unrelated activity (including commingling).",
  USD_ACCOUNT_CERT_CUSTOMER_ONLY_USE_LABEL: 'Customer-only use',
  USD_ACCOUNT_CERT_LAWFUL_USE:
    "I certify that funds are lawful and known, this account will be used only for Caliza-permitted activity, and no funds or activity involve illicit or sanctioned persons or entities, per Caliza's {0}.",
  USD_ACCOUNT_CERT_LAWFUL_USE_LABEL: 'Authorized & Lawful Use',
  USD_ACCOUNT_CERT_LAWFUL_USE_LINK: 'AML Policy',
  USD_ACCOUNT_CERT_TERMS:
    "I certify that I have read Caliza's {0} and {1} in their entirety and agree to be bound by them.",
  USD_ACCOUNT_CERT_TERMS_LABEL: 'Terms & Conditions',
  USD_ACCOUNT_CERT_TERMS_LINK: 'Terms & Conditions',
  USD_ACCOUNT_CERT_TERMS_PRIVACY_LINK: 'Privacy Policy',
  USD_ACCOUNT_CREATION_ERROR: 'An error occurred while creating your account. Please try again.',
  USD_ACCOUNT_CREATION_TIMEOUT:
    'Account creation is taking longer than expected. Please close this dialog and check back in a few moments.',
  USD_ACCOUNT_DESCRIPTION:
    'Use these details to receive USD transfers. Funds will be credited to the account balance.',
  USD_ACCOUNT_TERMS_DESCRIPTION:
    'Please review and accept the following certifications to create the USD account.',
  USD_BALANCE: 'USD Balance',
  USD_BALANCE_HEADLINE: 'Hold and pay out in USD',
  USD_BALANCE_HELPER: "Fund from local rails or stablecoins. Send USD payouts under Caliza's name.",
  USD_BALANCE_SUBTITLE: 'Hold and transfer USD',
  USD_BANNER_DESCRIPTION:
    'Hold USD and send payouts by default. Add USD accounts for ACH/Wire/SWIFT deposits, named payouts, and reconciliation.',
  USD_BANNER_TITLE: 'New: USD balances now work without a USD account.',
  USD_FOR_DOMESTIC_ACH_AND_WIRES_ONLY: 'USD (ACH and Wires)',
  USER: 'user',
  USERS: 'users',
  USE_CUSTOMER_BALANCE: 'Use the customer balance',
  USE_KEY: 'Use key',
  USE_YOUR_CALIZA_BALANCE: 'Use your Caliza balance',
  US_DOLLAR: 'US Dollar',
  VALIDATION_ACTIVE_USER_CONFLICT: 'This email address is already linked to an active user',
  VALIDATION_CNAPS_CODE_INVALID: 'CNAPS code must be exactly 12 digits',
  VALIDATION_CVU_INVALID: 'CVU or CBU must be exactly 22 digits',
  VALIDATION_IFSC_CODE_INVALID: 'IFSC code must be 4 letters, 0, then 6 alphanumeric characters',
  VALIDATION_INVALID_SWIFT_CHARACTERS:
    "{0} contains invalid characters. Only alphanumeric characters, spaces, and the following symbols are allowed: / - ? : ( ) . , ' +",
  VALIDATION_MSISDN_INVALID: 'Phone number must be in international format, e.g. +254712345678',
  VALIDATION_PASSWORD_MIN_12: 'Password must have a minimum of 12 characters',
  VALIDATION_PASSWORD_NUMBER: 'Password must have a minimum of 1 number',
  VALIDATION_PASSWORD_SPECIAL_CHARACTER: 'Password must have a minimum of 1 special character',
  VALIDATION_REQUIRED: '{0} is required',
  VALIDATION_ROUTING_CODE_INVALID: 'Routing code must be 8 or 9 digits',
  VALIDATION_SWIFT_BIC_COUNTRY_MISMATCH:
    "The SWIFT/BIC code's country does not match the selected destination country. Check the SWIFT code or change the country.",
  VALIDATION_TOO_LONG_16: '{0} must be less than 16 characters',
  VALIDATION_TOO_LONG_20: '{0} must be less than 20 characters',
  VALIDATION_TOO_LONG_70: '{0} must be less than 70 characters',
  VALIDATION_USER_CONFLICT: 'An invite was already sent to this email to join your team',
  VALUE: 'Value',
  VARIABLE: 'Variable',
  VA_ACCOUNTS_DESCRIPTION:
    'Create dedicated accounts with unique account numbers for ACH, Wires, RTP and SWIFT.',
  VA_ACCOUNTS_HEADLINE: 'Receive and send USD in your name',
  VA_BENEFIT_DEDICATED_DESC: 'Unique account numbers assigned exclusively to this customer',
  VA_BENEFIT_DEDICATED_TITLE: 'Dedicated accounts',
  VA_BENEFIT_MULTIPLE_DESC: 'Create multiple accounts for different purposes or business units',
  VA_BENEFIT_MULTIPLE_TITLE: 'Multiple accounts',
  VA_BENEFIT_RAILS_DESC: 'Receive deposits via all major US payment rails',
  VA_BENEFIT_RAILS_TITLE: 'ACH, Wire, SWIFT',
  VA_DEPOSITS_FOOTER: 'Deposits to these accounts are reflected in your USD balance above.',
  VA_SECTION_SUBTITLE: 'Create multiple dedicated accounts to receive and send USD in your name.',
  VERIFICATION_STATUS: 'Verification status',
  VERIFY: 'Verify',
  VERIFY_BUSINESS_ADDRESS: 'Address',
  VERIFY_BUSINESS_ADDRESS_LABEL: 'Address',
  VERIFY_BUSINESS_ADD_ANOTHER_OWNER: 'Add another owner',
  VERIFY_BUSINESS_ADD_SOCIAL_MEDIA: 'Add another social media channel',
  VERIFY_BUSINESS_ANNUAL_INCOME: 'Annual income',
  VERIFY_BUSINESS_BANK_STATEMENT: 'Bank account statement',
  VERIFY_BUSINESS_BANNER: 'Verify your business to send your first payment',
  VERIFY_BUSINESS_BENEFICIAL_OWNERS_DESC:
    'A beneficial owner is any individual who directly or indirectly owns 25% or more of your company.',
  VERIFY_BUSINESS_BENEFICIAL_OWNERS_TITLE: 'Beneficial owners',
  VERIFY_BUSINESS_BENEFICIAL_OWNER_ADDRESS_QUESTION: "What is the beneficial owner's address?",
  VERIFY_BUSINESS_BENEFICIAL_OWNER_COUNTER: 'Beneficial owner #{0}',
  VERIFY_BUSINESS_BUSINESS_CONTACT_DESC:
    'The business representative is the primary point of contact who will manage the business relationship and ongoing operations with Caliza.',
  VERIFY_BUSINESS_BUSINESS_CONTACT_TITLE: 'Business contact',
  VERIFY_BUSINESS_CITY: 'City',
  VERIFY_BUSINESS_CNPJ: 'CNPJ',
  VERIFY_BUSINESS_CNPJ_FORMAT: 'CNPJ must follow this format: 12.345.678/9012-34',
  VERIFY_BUSINESS_CNPJ_QUESTION: 'What is the CNPJ?',
  VERIFY_BUSINESS_CNPJ_REGISTRATION: 'CNPJ registration',
  VERIFY_BUSINESS_COMMERCIAL_NAME: 'Commercial business name',
  VERIFY_BUSINESS_COMMERCIAL_NAME_QUESTION: "What is the company's commercial business name?",
  // New hardcoded strings that need translation
  VERIFY_BUSINESS_COMPANY_DETAILS_TITLE: 'Company details',
  VERIFY_BUSINESS_COMPANY_PROFILE_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_COMPANY_PROFILE_TITLE: 'Company profile',
  VERIFY_BUSINESS_CONTACT_INFORMATION: 'Contact information',
  VERIFY_BUSINESS_CONTACT_INFORMATION_QUESTION: 'What is their contact information?',
  VERIFY_BUSINESS_CONTACT_LABEL: 'Contact',
  VERIFY_BUSINESS_CONTACT_QUESTION: 'Who is the point of contact for the business?',
  VERIFY_BUSINESS_COUNTRIES: 'Countries',
  VERIFY_BUSINESS_CUSTOMER_COUNTRIES_QUESTION: 'What countries are your customers located in?',
  VERIFY_BUSINESS_CUSTOMER_DESCRIPTION: 'A description of your customer',
  VERIFY_BUSINESS_CUSTOMER_INDUSTRIES_QUESTION:
    'Which industries do you have customers in? Select all that apply',
  VERIFY_BUSINESS_CUSTOMER_QUANTITY_QUESTION: 'How many approximate customers do you have?',
  VERIFY_BUSINESS_CUSTOMER_TYPE_QUESTION:
    'What type of customers do you have? Select all that apply',
  VERIFY_BUSINESS_DOCUMENTS: 'Documents',
  VERIFY_BUSINESS_DOCUMENTS_DESCRIPTION:
    'Please upload the company documents below. We support PDF, JPG, JPEG, PNG, and Word formats of a maximum size of [20] MB',
  VERIFY_BUSINESS_DOCUMENTS_TITLE: 'Documents',
  VERIFY_BUSINESS_EMAIL: 'Email',
  VERIFY_BUSINESS_EMAIL_QUESTION: 'What is their email?',
  VERIFY_BUSINESS_ENTITY_TYPE: 'Entity type',
  VERIFY_BUSINESS_ENTITY_TYPE_QUESTION: 'What is the entity type?',
  VERIFY_BUSINESS_EXPECTED_RANGE: 'Expected $ range',
  VERIFY_BUSINESS_FINANCIAL_INSTITUTION_QUESTION: 'Are you a payment or financial institution',
  VERIFY_BUSINESS_FIRST_NAME: 'First name',
  VERIFY_BUSINESS_INCORPORATION_DOCUMENT: 'Incorporation document or articles of incorporation',
  VERIFY_BUSINESS_INDUSTRY_QUESTION: 'What industry is your business in?',
  VERIFY_BUSINESS_LAST_NAME: 'Last name',
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME: 'Legal entity name',
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME_HELP:
    'Legal entity name must exactly match "NOME EMPRESARIAL" in your company\'s "CADASTRO NACIONAL DA PESSOA JURÍDICA" document.',
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME_QUESTION: 'What is the legal entity name?',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_DESC:
    'A legal representative is an individual with legal authority and powers to represent your company.',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_LABEL: 'Legal representative',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_QUESTION:
    'Who is the legal representative of this business?',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_TITLE: 'Legal representative',
  VERIFY_BUSINESS_LICENSE_REQUIRED:
    'Are you required to have a license to operate in Brazil or another jurisdiction?',
  VERIFY_BUSINESS_MAIN_ADDRESS_QUESTION: "What is the company's main business address?",
  VERIFY_BUSINESS_MAIN_INDUSTRY: 'Main industry',
  VERIFY_BUSINESS_NATIONALITY: 'Nationality',
  VERIFY_BUSINESS_NUMBER_OF_CUSTOMERS: 'Number of customers',
  VERIFY_BUSINESS_OCCUPATION: 'Occupation',
  VERIFY_BUSINESS_ONLINE_PRESENCE_DESC:
    'Please share any other websites or online channels that could help us to better understand your business. These include social media accounts, e-commerce stores, and app store links.',
  // Additional tr() arguments that need symbols
  VERIFY_BUSINESS_ONLINE_PRESENCE_TITLE: 'Online presence',
  VERIFY_BUSINESS_OPERATIONS_TITLE: 'Business operations',
  VERIFY_BUSINESS_OPERATION_COUNTRIES_QUESTION: 'Which countries do you operate in?',
  VERIFY_BUSINESS_OPERATION_STARTED: 'Operation started',
  VERIFY_BUSINESS_OPERATION_START_QUESTION: 'When did the company start operations?',
  VERIFY_BUSINESS_ORGANIZATION_TITLE: 'Organization',
  VERIFY_BUSINESS_OWNER: 'Owner',
  VERIFY_BUSINESS_PERCENTAGE_OWNERSHIP: 'Percentage ownership',
  VERIFY_BUSINESS_PHONE: 'Phone',
  VERIFY_BUSINESS_PHONE_NUMBER: 'Phone number',
  VERIFY_BUSINESS_PHONE_QUESTION: 'What is their phone number?',
  VERIFY_BUSINESS_POSITION: 'Position',
  VERIFY_BUSINESS_POSITION_QUESTION: 'What is their position?',
  VERIFY_BUSINESS_POWER_OF_ATTORNEY: 'Power of attorney',
  VERIFY_BUSINESS_POWER_OF_ATTORNEY_HELP:
    'Please provide a standing general Power of Attorney or a limited Power of Attorney that assigns authority to open accounts and sign contracts on behalf of the business',
  VERIFY_BUSINESS_SERVICES_DESCRIPTION: 'Description of products and services (Min 8 words)',
  VERIFY_BUSINESS_SERVICES_QUESTION: 'What products or services does your business offer?',
  VERIFY_BUSINESS_SOCIAL_MEDIA_QUESTION: 'What are your social media channels? (Optional)',
  VERIFY_BUSINESS_SOLE_PROPRIETOR_SKIP:
    'This section is not required since you are a sole proprietorship',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS: 'Source of funds',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS_TITLE: 'Source of funds',
  VERIFY_BUSINESS_SOURCE_OF_WEALTH: 'Source of wealth',
  VERIFY_BUSINESS_STATE: 'State',
  VERIFY_BUSINESS_SUITE_FLOOR_APT: 'Suite / Floor / Apt',
  VERIFY_BUSINESS_SUPPORTED_ID_DOCS: 'Supported ID docs (Passport, DL or Registro Geral)',
  VERIFY_BUSINESS_TAX_ID: 'Tax ID',
  VERIFY_BUSINESS_THIRD_PARTY_QUESTION:
    'Do you intend to use Caliza to move funds on behalf of customers or other third parties?',
  VERIFY_BUSINESS_TITLE: 'Business information',
  VERIFY_BUSINESS_TYPICAL_CUSTOMER_QUESTION: 'Please describe your typical customer',
  VERIFY_BUSINESS_UPLOAD_ID: 'Upload Passport, DL or Registro Geral',
  VERIFY_BUSINESS_URL: 'URL',
  VERIFY_BUSINESS_USD_VOLUME_QUESTION:
    'What is the expected monthly $USD volume you will move using Caliza?',
  VERIFY_BUSINESS_WEBSITE_LINK: 'Website link',
  VERIFY_BUSINESS_WEBSITE_QUESTION: 'What is your business website?',
  VERIFY_BUSINESS_YOUR_CUSTOMERS_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_YOUR_CUSTOMERS_TITLE: 'Your customers',
  VERIFY_BUSINESS_ZIP: 'Zip',
  VERIFY_YOUR_BUSINESS: 'Verify your business',
  VET: 'Total Effective Value',
  VET_TOOLTIP:
    'VET (Valor Efetivo Total) represents the implied all-in rate, considering spread, other fees, and applicable taxes',
  VIEWER: 'Viewer',
  VIEWER_DESCRIPTION:
    'Read‑only access to company accounts, view and download transaction history and activity reports',
  VIEW_ACTIVITY: 'View and download transaction history and activity reports',
  VIEW_AND_DOWNLOAD_TRANSACTIONS: 'View and download transaction history and activity report',
  VIEW_USD_ACCOUNT: 'View USD account',
  VIRTUAL_ACCOUNTS_COUNT: 'Virtual Accounts ({0} accounts)',
  VOLUME_PROCESSED: 'Volume with markup',
  VOLUME_PROCESSED_TOOLTIP:
    'Only includes completed transactions where FX markup was applied (i.e., transactions that generated earnings).',
  WALLET: 'Wallet',
  WALLET_ADDRESS_COPIED: 'Address copied successfully',
  WALLET_BALANCE_CURRENCY: 'Wallet balance ${0} {1}',
  WALLET_BALANCE_LEGACY: 'Wallet balance ${0} Digital dollars',
  WALLET_INFORMATION: 'Wallet information',
  WALLET_INFORMATION_WITH_CURRENCY: 'Wallet information ({0})',
  WEBHOOK_SECRET: 'Webhook secret',
  WEBHOOK_SECRET_ROTATED: 'Webhook secret rotated',
  WEBHOOK_SECRET_ROTATE_ERROR: 'Could not rotate webhook secret',
  WELCOME_BACK: 'Welcome back',
  WELCOME_TITLE: 'Welcome back, {0}',
  WE_ARE_DEPOSITING_YOUR_FUNDS: 'We are depositing your funds',
  WE_DONT_SUPPORT_YOUR_COUNTRY_YET: 'We don’t support your country yet',
  WE_RECEIVED_PAYMENT_INITIATED: "We've received your payment and initiated your transfer",
  WE_RECEIVED_PAYMENT_INITIATED_DESCRIPTION:
    'Check your history to track the status of the transfer. Transaction details can take a few minutes before they appear.',
  WHERE_SENDING_FUNDS: 'Where are you sending funds?',
  WHO_ARE_YOU_DEPOSITING_FOR: 'Who are you depositing for?',
  WHO_ARE_YOU_SENDING_FUNDS_ON_BEHALF_OF: 'Who are you sending funds on behalf of?',
  WIRE: 'Wire',
  WITHDRAW: 'Withdraw',
  WITHDRAWAL: 'Withdrawal',
  WITHDRAWAL_ACCOUNT: 'Withdrawal account',
  WITHDRAWAL_TO: 'Withdrawal to {0}',
  WITHDRAWAL_TRANSACTION_HASH: 'Withdrawal transaction hash',
  WITHDRAW_FUNDS: 'Withdraw funds',
  YEAR: 'Year',
  YES: 'Yes',
  YOU: 'You',
  YOURE_ALMOST_DONE: "You're almost done!",
  YOUR_ACCOUNT: 'Your account',
  YOUR_ACCOUNTS: 'Your accounts',
  YOUR_BALANCES: 'Your balances',
  YOUR_CALIZA_PASSWORD: 'Your Caliza password',
  YOUR_EARNINGS: 'Your earnings',
  YOUR_FUNDS_HAVE_BEEN_ADDED: 'Your funds have been added',
  YOUR_FUNDS_HAVE_BEEN_SENT: 'Your funds have been sent',
  YOUR_FX_MARKUP: 'Your FX Markup',
  YOUR_ORGANIZATION: 'Your organization',
  YOU_CLAIM: 'You claim',
  YOU_DO_NOT_HAVE_ENOUGH_FUNDS: 'You do not have enough enough funds to complete this transaction',
  YOU_PULL_FROM_CUSTOMER: 'You pull from customer',
  YOU_RECEIVE: 'You receive',
  YOU_SEND: 'You send',
  YOU_STILL_BE_ABLE_TO_EXPLORE_PRODUCT_DESCRIPTION:
    'You will still be able to explore our products, but not send any payments. We will notify you once we are active in your country.',
  ZERO_RESULTS_FOUND: '0 results found',
  ZIP: 'Zip',
};
export default strings;
